// Build433: paragraph metadata must not match the alignment-control grid selector.
// Build432: justified paragraphs, shared whitespace advances.
// Build431: persisted paragraph alignment for standard and additional straight text.
// Build424: editable attached arrow labels; NFC supplies defaults, not a visibility lock.
// Build405: Italian editor localization; historical predecessor retained.
// Build404: Social vectors share the 500% owner limit.
// Build401: light silver material in presentation PNGs.
// Build398: optional transparent artwork capture for metallic 360 previews.
// Build362: one curved path layout for live, proof and production.
// Build 20260912-352: retain structurally identical live SVG children.
// Build 20260911-342: rich text ranges.
// Build 20260910-333: rotate text, pill and persisted output together.
(() => {
  if (window.__smoofDesignRendererV323) {
    return;
  }

  window.__smoofDesignRendererV323 = true;
  window.__smoofDesignRendererV321 = true;
  window.__smoofDesignRendererV320 = true;
  window.__smoofDesignRendererV319 = true;
  window.__smoofDesignRendererV318 = true;
  window.__smoofDesignRendererV314 =
    true;

  window.__smoofDesignRendererV313 = true;
  window.__smoofDesignRendererV311 = true;

  window.__smoofDesignRendererV310 =
    true;

  window.__smoofDesignRendererV39 =
    true;

  window.__smoofDesignRendererV38 =
    true;

  window.__smoofDesignRendererV37 =
    true;

  window.__smoofDesignRendererV36 =
    true;

  window.__smoofDesignRendererV35 =
    true;

  window.__smoofDesignRendererV34 =
    true;

  window.__smoofDesignRendererV33 =
    true;

  window.__smoofDesignRendererV3 =
    true;

  const VERSION =
    'smoof-design-schema-1.0';

  const RENDERER_BUILD =
    'v3.1-native-nfc-20260814';

  /*
   * `build` ist die stabile Schnittstellenkennung, gegen die Proof- und
   * Produktionsmodul prüfen. Interne Hotfixes bekommen deshalb eine eigene
   * Revisionskennung und dürfen `build` nicht verändern.
   */
  const EXTRA_STYLE_BUILD = '20260910-333';
  const RENDERER_REVISION =
    'transparent-preview-20260916-398';

  const RENDERER_SCRIPT_URL =
    document.currentScript?.src || '';

  const STAINLESS_TEXTURE_URL =
    RENDERER_SCRIPT_URL
      ? new URL(
          'smoof-stainless-steel-v1.png',
          RENDERER_SCRIPT_URL
        ).href
      : '';

  const FONTKIT_URL =
    'https://cdn.jsdelivr.net/npm/fontkit@2.0.4/+esm';

  const STAGE_SELECTOR =
    '.po-livePreview-stage .konvajs-content';

  const SVG_NS =
    'http://www.w3.org/2000/svg';

  const XLINK_NS =
    'http://www.w3.org/1999/xlink';

  const VIEWBOX_SIZE = 1000;
  const PRINT_RADIUS = 353.4;
  /*
   * Weißer Kontrastsaum und dunkle Hilfslinie erhalten getrennte Radien.
   * Beide inneren Kanten beginnen exakt auf der Druckkante. Dadurch liegt die
   * dunkle Linie direkt am Motiv, während der weiße Saum nur außen sichtbar
   * bleibt und die Druckfläche nicht überdeckt.
   */
  const PROOF_TRIM_GUIDE_WHITE_OFFSET =
    3.5;
  const PROOF_TRIM_GUIDE_DARK_OFFSET =
    1.2;

  /*
   * Safari ignoriert bei SVG-Text die erwartete optische Zentrierung von
   * dominant-baseline="central". Gemessen wird der Text dort um exakt rund
   * 0,342 em nach oben versetzt; Chrome benötigt diese Korrektur nicht.
   */
  const IS_SAFARI =
    /Safari/i.test(navigator.userAgent) &&
    !/(Chrome|Chromium|CriOS|Edg|OPR|Android)/i.test(
      navigator.userAgent
    );

  const SAFARI_TEXT_BASELINE_OFFSET_EM =
    0.342;

  const QR_PANEL = {
    x: 372,
    y: 372,
    width: 256,
    height: 256,
    radius: 18
  };

  function qrVisible(model = null) {
    return typeof model?.qr?.visible === 'boolean'
      ? model.qr.visible
      : true;
  }

  function qrBackingVisible(model = null) {
    if (!qrVisible(model)) {
      return false;
    }
    if (document.documentElement.dataset.smoofQrBackground === 'transparent') {
      return false;
    }
    if (typeof model?.qr?.backingVisible === 'boolean') {
      return model.qr.backingVisible;
    }
    if (typeof model?.qr?.whiteBackground === 'boolean') {
      return model.qr.whiteBackground;
    }
    return true;
  }

  function qrBackingColor(model = null) {
    const value = String(model?.qr?.backingColor || '#FFFFFF').trim();
    return /^#[0-9a-f]{6}$/i.test(value)
      ? value.toUpperCase()
      : '#FFFFFF';
  }

  function qrCodeColor(model = null) {
    if (model?.productVariant?.printProcess === 'laser') {
      return '#000000';
    }
    const value = String(model?.qr?.codeColor || '#000000').trim();
    return /^#[0-9a-f]{6}$/i.test(value)
      ? value.toUpperCase()
      : '#000000';
  }

  function qrPanel(model = null) {
    const source = model?.qr || window.SmoofQrGeometryTools?.getState?.() || {};
    const scale = Math.max(0.5, Math.min(1.5, Number(source.scale) || 1));
    const width = QR_PANEL.width * scale;
    const height = QR_PANEL.height * scale;
    const centerX = Math.max(0, Math.min(1, Number(source.x) || 0.5)) * VIEWBOX_SIZE;
    const centerY = Math.max(0, Math.min(1, Number(source.y) || 0.5)) * VIEWBOX_SIZE;
    return {
      x: centerX - width / 2,
      y: centerY - height / 2,
      width,
      height,
      radius: QR_PANEL.radius * scale,
      scale,
      centerX,
      centerY
    };
  }

  /*
   * Exakt dasselbe transparente QR-Asset, das Easify im Editor-Hintergrund
   * des Testprodukts verwendet. Die Position ist bereits auf 1600 x 1600
   * angelegt und wird deshalb proportional auf den 1000er-ViewBox skaliert.
   */
  const EDITOR_QR_URL =
    'https://cdn.shopify.com/s/files/1/0996/4136/0721/files/Placeholder_config7.png?v=1785497532';

  const ARROW_URLS = {
    left:
      'https://cdn.shopify.com/s/files/1/0996/4136/0721/files/Left.svg?v=1785255586',
    right:
      'https://cdn.shopify.com/s/files/1/0996/4136/0721/files/Right.svg?v=1785255586'
  };

  const NFC_ICON_BOX = {
    size: 78
  };

  const NFC_VIEWBOX_SIZE = 109.77;

  /*
   * Das NFC-Zeichen ist absichtlich als lokale Vektorgeometrie hinterlegt.
   * Damit verwenden Live-SVG, Proof-PNG und Produktionsvorschau exakt dieselbe
   * Quelle. Es gibt keinen externen SVG-Download, keine CSS-Klassen im Asset
   * und keine zweite QR/NFC-Overlay-Stufe mehr.
   */
  const NFC_ICON_PATHS = Object.freeze([
    'M67.34,54.55c0,1.59-1.3,2.87-2.89,2.86-.59,0-1.16-.19-1.64-.53-4.81-3.39-11.23-3.4-16.05-.03-1.27.96-3.07.7-4.02-.57-.95-1.27-.7-3.07.57-4.02.05-.04.1-.08.15-.11,6.81-4.77,15.88-4.76,22.67.04.76.54,1.21,1.42,1.2,2.36',
    'M73.09,43.39c0,1.59-1.29,2.87-2.88,2.87-.53,0-1.05-.15-1.51-.43-8.51-5.28-19.27-5.3-27.8-.05-1.35.83-3.13.41-3.96-.94-.84-1.35-.42-3.12.93-3.96,10.38-6.39,23.49-6.37,33.85.06.85.53,1.36,1.45,1.36,2.44',
    'M79.03,31.81c-.01,1.59-1.31,2.86-2.89,2.85-.5,0-.99-.14-1.42-.39-12.3-7.22-27.53-7.25-39.86-.07-1.43.68-3.15.08-3.83-1.36-.61-1.27-.2-2.81.96-3.61,14.12-8.23,31.59-8.2,45.68.08.86.53,1.38,1.48,1.36,2.49',
    'M47.57,68.28v18.4h-2.22c-.33,0-.6-.05-.83-.16-.22-.1-.44-.29-.66-.55l-8.67-10.97c.03.33.06.65.07.95.01.31.02.6.02.87v9.86h-3.76v-18.4h2.25c.19,0,.34,0,.47.03.13.02.24.05.34.09.1.05.2.11.29.2s.2.2.31.34l8.75,11.05c-.04-.35-.07-.7-.09-1.03-.02-.33-.03-.65-.03-.94v-9.74h3.76Z',
    'M55.42,71.56v4.66h6.29v3.3h-6.29v7.16h-4.29v-18.4h11.84v3.28h-7.55Z',
    'M77.68,81.92c.1,0,.2.02.3.06.1.04.2.1.29.2l1.69,1.78c-.74.97-1.67,1.7-2.78,2.19-1.11.49-2.43.74-3.96.74-1.4,0-2.65-.24-3.76-.71-1.11-.48-2.05-1.13-2.82-1.97-.77-.84-1.36-1.83-1.77-2.98-.41-1.15-.62-2.4-.62-3.74s.22-2.63.67-3.78,1.07-2.14,1.88-2.97c.81-.83,1.78-1.48,2.9-1.95,1.13-.46,2.37-.69,3.73-.69.69,0,1.34.06,1.95.18s1.18.29,1.71.51c.53.21,1.02.47,1.46.78.45.3.84.63,1.19.99l-1.44,1.93c-.09.12-.2.23-.33.32s-.3.14-.53.14c-.15,0-.29-.03-.43-.1-.13-.07-.28-.15-.43-.25-.15-.1-.32-.2-.5-.32s-.4-.22-.64-.32c-.25-.1-.54-.18-.87-.25-.33-.07-.72-.1-1.17-.1-.71,0-1.35.13-1.94.39-.59.26-1.09.64-1.51,1.14-.43.5-.75,1.12-.99,1.84-.23.73-.35,1.56-.35,2.49s.13,1.78.38,2.51.61,1.35,1.05,1.85c.44.5.96.88,1.55,1.14.59.26,1.22.39,1.89.39.39,0,.74-.02,1.06-.06.32-.04.62-.1.9-.19s.54-.21.78-.35.49-.33.75-.56c.1-.08.21-.15.33-.21.12-.05.24-.08.37-.08Z'
  ]);

  const arrowAssetCache =
    new Map();

  let editorQrAssetPromise = null;
  let editorQrImagePromise = null;

  const fontFaceCache =
    new Map();

  const laserFontCache =
    new Map();

  let fontKitPromise = null;
  let laserPathScope = null;
  let stainlessTextureImagePromise = null;

  const logoDataCache =
    new Map();

  let liveSvg = null;
  let liveTextCanvas = null;
  let currentStage = null;
  let renderPending = false;
  let renderSequence = 0;

  async function requestResource(
    url,
    responseType = 'text'
  ) {
    if (
      typeof window.fetch ===
      'function'
    ) {
      const response =
        await window.fetch(
          url,
          {
            credentials: 'omit'
          }
        );

      if (!response.ok) {
        throw new Error(
          `Resource ${response.status}`
        );
      }

      return {
        contentType:
          response.headers.get(
            'content-type'
          ) || '',
        body:
          responseType ===
          'arrayBuffer'
            ? await response
                .arrayBuffer()
            : await response.text()
      };
    }

    return new Promise(
      (resolve, reject) => {
        const request =
          new XMLHttpRequest();

        request.open(
          'GET',
          url,
          true
        );

        request.responseType =
          responseType ===
          'arrayBuffer'
            ? 'arraybuffer'
            : 'text';

        request.onload = () => {
          if (
            request.status < 200 ||
            request.status >= 300
          ) {
            reject(
              new Error(
                `Resource ${request.status}`
              )
            );

            return;
          }

          resolve({
            contentType:
              request.getResponseHeader(
                'content-type'
              ) || '',
            body:
              responseType ===
              'arrayBuffer'
                ? request.response
                : request.responseText
          });
        };

        request.onerror = () => {
          reject(
            new Error(
              'Resource request failed'
            )
          );
        };

        request.send();
      }
    );
  }

  function stageElement() {
    return document.querySelector(
      STAGE_SELECTOR
    );
  }

  function clamp(
    value,
    minimum,
    maximum
  ) {
    return Math.min(
      maximum,
      Math.max(
        minimum,
        value
      )
    );
  }

  function numberValue(
    value,
    fallback = 0
  ) {
    const number =
      Number.parseFloat(value);

    return Number.isFinite(number)
      ? number
      : fallback;
  }

  /*
   * Akzeptiert sowohl das historische 1000er-Editorraster (500 = Mitte)
   * als auch das kanonische normalisierte Format (0.5 = Mitte).
   */
  function normalizedNfcCoordinate(
    value
  ) {
    const number = Number(value);

    if (!Number.isFinite(number)) {
      return 0.5;
    }

    const normalized =
      Math.abs(number) > 1
        ? number / VIEWBOX_SIZE
        : number;

    return clamp(
      normalized,
      0,
      1
    );
  }

  function round(
    value,
    digits = 4
  ) {
    const factor =
      10 ** digits;

    return Math.round(
      value * factor
    ) / factor;
  }

  function normalizedRect(
    element,
    stageRect
  ) {
    if (!element) return null;

    const screenRect =
      element.getBoundingClientRect();

    let rect = screenRect;

    /*
     * Standing front presentation scales every artwork layer around the
     * stage centre. Reading those already transformed screen coordinates
     * into the render model and then scaling the generated SVG again would
     * move text/logo content towards the centre twice. Reconstruct the
     * layer's untransformed rectangle before normalising; the shared front
     * presentation transform is applied exactly once afterwards.
     */
    if (
      document.documentElement.dataset
        .smoofQhsMode === 'product'
    ) {
      const presentationLayer =
        element.closest(
          '[data-smoof-standing-artwork-layer]'
        );

      const transform = presentationLayer
        ? getComputedStyle(
            presentationLayer
          ).transform
        : '';

      const matrix =
        transform.match(
          /^matrix\(([^)]+)\)$/
        );

      const values = matrix
        ? matrix[1]
            .split(',')
            .map(Number)
        : [];

      const scaleX =
        Math.hypot(
          values[0] || 0,
          values[1] || 0
        );

      const scaleY =
        Math.hypot(
          values[2] || 0,
          values[3] || 0
        );

      if (
        scaleX > 0 &&
        scaleY > 0 &&
        Math.abs(scaleX - scaleY) <
          0.0001 &&
        Math.abs(scaleX - 1) >
          0.0001
      ) {
        const stageCenterX =
          stageRect.left +
          stageRect.width / 2;

        const stageCenterY =
          stageRect.top +
          stageRect.height / 2;

        const rectCenterX =
          screenRect.left +
          screenRect.width / 2;

        const rectCenterY =
          screenRect.top +
          screenRect.height / 2;

        const width =
          screenRect.width / scaleX;

        const height =
          screenRect.height / scaleY;

        const centerX =
          stageCenterX +
          (
            rectCenterX -
            stageCenterX
          ) / scaleX;

        const centerY =
          stageCenterY +
          (
            rectCenterY -
            stageCenterY
          ) / scaleY;

        rect = {
          left: centerX - width / 2,
          top: centerY - height / 2,
          width,
          height
        };
      }
    }

    if (
      !rect.width ||
      !rect.height ||
      !stageRect.width ||
      !stageRect.height
    ) {
      return null;
    }

    return {
      x: round(
        (
          rect.left -
          stageRect.left
        ) /
        stageRect.width *
        VIEWBOX_SIZE
      ),
      y: round(
        (
          rect.top -
          stageRect.top
        ) /
        stageRect.height *
        VIEWBOX_SIZE
      ),
      width: round(
        rect.width /
        stageRect.width *
        VIEWBOX_SIZE
      ),
      height: round(
        rect.height /
        stageRect.height *
        VIEWBOX_SIZE
      )
    };
  }

  function centerOf(rect) {
    return {
      x:
        rect.x +
        rect.width / 2,
      y:
        rect.y +
        rect.height / 2
    };
  }

  function positionedFrameCenter(
    frame
  ) {
    const left =
      frame?.style?.left || '';

    const top =
      frame?.style?.top || '';

    if (
      !left.endsWith('%') ||
      !top.endsWith('%')
    ) {
      return null;
    }

    const x = parseFloat(left);
    const y = parseFloat(top);

    if (
      !Number.isFinite(x) ||
      !Number.isFinite(y)
    ) {
      return null;
    }

    return {
      x: x / 100 * VIEWBOX_SIZE,
      y: y / 100 * VIEWBOX_SIZE
    };
  }

  function cssValue(
    element,
    property,
    fallback = ''
  ) {
    if (!element) return fallback;

    return (
      getComputedStyle(element)
        .getPropertyValue(property)
        .trim() ||
      fallback
    );
  }

  function firstFontFamily(value) {
    return String(value || 'Arial')
      .split(',')[0]
      .trim()
      .replace(
        /^["']|["']$/g,
        ''
      ) ||
      'Arial';
  }

  function productForm() {
    return Array.from(
      document.querySelectorAll(
        'form[action*="/cart/add"]'
      )
    ).find(form =>
      form.querySelector(
        'button[type="submit"]'
      )
    ) || null;
  }

  function propertyValue(name) {
    const form = productForm();
    if (!form) return '';

    return (
      Array.from(
        form.querySelectorAll(
          'input'
        )
      ).find(input =>
        input.name === name
      )?.value ||
      ''
    );
  }

  function propertyBoolean(name) {
    return /^(1|true|ja|yes)$/i.test(propertyValue(name));
  }

  function layerOpacity(id) {
    const value = Number(window.SmoofLayerOpacityTools?.get?.(id));
    return Number.isFinite(value)
      ? Math.min(1, Math.max(0, value))
      : 1;
  }

  function setProperty(
    form,
    name,
    value
  ) {
    let input =
      Array.from(
        form.querySelectorAll(
          'input'
        )
      ).find(candidate =>
        candidate.name === name &&
        candidate.type !== 'file'
      );

    if (!input) {
      input =
        document.createElement(
          'input'
        );

      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }

    input.value = value;
  }

  function getPrintDiameterMm() {
    const variantDiameter =
      Number(
        window
          .SmoofProductVariant
          ?.get?.()
          ?.diameterMm
      );

    if (
      Number.isFinite(
        variantDiameter
      ) &&
      variantDiameter > 0
    ) {
      return variantDiameter;
    }

    const candidates =
      Array.from(
        document.querySelectorAll(
          [
            'input[name*="Größe der Druckfläche"]',
            'input[name*="Druckfläche"]',
            'input[name*="Print area"]',
            'input[name*="print area"]'
          ].join(',')
        )
      );

    const rawValue =
      candidates.find(input =>
        input.offsetParent !== null
      )?.value ||
      candidates[0]?.value ||
      '80';

    const match =
      String(rawValue).match(
        /(\d+(?:[.,]\d+)?)/
      );

    const diameter =
      Number(
        match?.[1]?.replace(
          ',',
          '.'
        )
      );

    return (
      Number.isFinite(diameter) &&
      diameter > 0
    )
      ? diameter
      : 80;
  }

  function readRichModel(frame,content,stageRect) {
    const id=frame.dataset.smoofEditorItem;
    const data=id?.startsWith('custom-text-')?window.SmoofCustomTextTools?.richState?.(id):window.SmoofTextTools?.richState?.(Number(id?.split('-')[1]));
    const textAlign=content.dataset.smoofParagraphAlign || getComputedStyle(content).textAlign;
    if(!data || (!data.runs?.length && !['left','right','justify'].includes(textAlign)))return {};
    const css=getComputedStyle(frame),unit=VIEWBOX_SIZE/stageRect.width;
    const richBox={padX:(numberValue(css.paddingLeft)+numberValue(css.paddingRight)+numberValue(css.borderLeftWidth)+numberValue(css.borderRightWidth))*unit,padY:(numberValue(css.paddingTop)+numberValue(css.paddingBottom)+numberValue(css.borderTopWidth)+numberValue(css.borderBottomWidth))*unit};
    return {value:data.text,runs:data.runs,textAlign,richBox,canonicalStyle:data.base.canonicalStyle,maxWidth:(parseFloat(content.style.maxWidth)||stageRect.width*.62)/stageRect.width*VIEWBOX_SIZE};
  }

  function textPillRect(frame, stageRect) {
    if (!(Number(frame?.dataset.smoofTextRotation) || 0)) return normalizedRect(frame, stageRect);
    const center = positionedFrameCenter(frame);
    if (!center || !stageRect.width || !stageRect.height) return null;
    const css = getComputedStyle(frame);
    const extra = css.boxSizing === 'border-box' ? 0 : 1;
    const width = (numberValue(css.width) + extra * (numberValue(css.paddingLeft) + numberValue(css.paddingRight) + numberValue(css.borderLeftWidth) + numberValue(css.borderRightWidth))) / stageRect.width * VIEWBOX_SIZE;
    const height = (numberValue(css.height) + extra * (numberValue(css.paddingTop) + numberValue(css.paddingBottom) + numberValue(css.borderTopWidth) + numberValue(css.borderBottomWidth))) / stageRect.height * VIEWBOX_SIZE;
    return { x: round(center.x - width / 2), y: round(center.y - height / 2), width: round(width), height: round(height) };
  }

  function readTextLines(
    stageRect
  ) {
    return Array.from(
      document.querySelectorAll(
        '[data-smoof-text-frame]'
      )
    )
      .sort(
        (a, b) =>
          numberValue(
            a.dataset
              .smoofTextFrame
          ) -
          numberValue(
            b.dataset
              .smoofTextFrame
          )
      )
      .map((frame, index) => {
        const editorItemId = frame.dataset.smoofEditorItem || `text-${index}`;
        const curved=window.SmoofCurvedText?.model(frame);
        if(curved)return {...curved,id:editorItemId.startsWith('custom-text-')?editorItemId:`text-${index+1}`,index,visible:frame.dataset.visible!=='false'&&!frame.hidden,opacity:editorItemId.startsWith('custom-text-')?(window.SmoofCustomTextTools?.getState(editorItemId)?.opacity??1):layerOpacity(editorItemId)};
        const content =
          frame.querySelector(
            '[data-smoof-text-content]'
          );

        const rect =
          normalizedRect(
            content,
            stageRect
          );

        if (!content || !rect) {
          return null;
        }

        const computed =
          getComputedStyle(content);

        const center =
          positionedFrameCenter(frame) || centerOf(rect);

        const pillElement = frame.querySelector('[data-smoof-text-pill]');
        const pillRect = textPillRect(frame, stageRect);
        const pillStyle = pillElement ? getComputedStyle(pillElement) : null;

        return {
          // Die IDs der drei Bestandszeilen bleiben unveraendert. Nur die
          // zusaetzlichen Texte behalten ihre explizite Custom-ID.
          id: editorItemId.startsWith('custom-text-')
            ? editorItemId
            : `text-${index + 1}`,
          index,
          editing:
            frame.dataset.editing ===
            'true',
          visible:
            frame.dataset.visible !==
              'false' &&
            !frame.hidden,
          opacity: editorItemId.startsWith('custom-text-')
            ? (window.SmoofCustomTextTools?.getState?.(editorItemId)?.opacity ?? 1)
            : layerOpacity(`text-${index}`),
          value:
            content.textContent || '',
          x: round(center.x),
          y: round(center.y),
          rotation: numberValue(frame.dataset.smoofTextRotation),
          fontFamily:
            firstFontFamily(
              computed.fontFamily
            ),
          fontSize: round(
            numberValue(
              computed.fontSize
            ) /
            stageRect.width *
              VIEWBOX_SIZE
          ),
          lineHeight: round(
            (numberValue(computed.lineHeight) || numberValue(computed.fontSize) * 1.08) /
              stageRect.width *
              VIEWBOX_SIZE
          ),
          fontWeight:
            String(
              computed.fontWeight ||
              '400'
            ),
          fontStyle:
            computed.fontStyle ||
            'normal',
          letterSpacing:
            computed.letterSpacing ===
              'normal'
              ? 0
              : round(
                  numberValue(
                    computed
                      .letterSpacing
                  ) /
                  stageRect.width *
                  VIEWBOX_SIZE
                ),
          color:
            computed.color ||
            '#000000',
          ...readRichModel(frame,content,stageRect),
          pill: pillElement && pillRect && pillStyle?.display !== 'none'
            ? {
                visible: true,
                ...pillRect,
                stroke: pillStyle.borderColor || '#000000',
                strokeWidth: round(numberValue(pillStyle.borderWidth) / stageRect.width * VIEWBOX_SIZE),
                fill: pillElement.dataset.smoofPillFillVisible === 'true'
                  ? (pillStyle.backgroundColor || '#ffffff')
                  : 'none'
              }
            : { visible: false }
        };
      })
      .filter(Boolean);
  }

  function readArrows(
    stageRect
  ) {
    return [
      'left',
      'right'
    ].map(side => {
      const graphic =
        document.querySelector(
          `[data-smoof-arrow-graphic="${side}"]`
        );

      const label =
        document.querySelector(
          `[data-smoof-arrow-label-graphic="${side}"]`
        );

      const state = window.SmoofArrowTools?.getState?.(side) || {};

      if (!graphic) {
        return null;
      }

      const count = Math.max(1, Math.min(4, Math.round(numberValue(state.count) || 4)));
      const symbol = window.SmoofPictogramLibrary?.has?.(state.symbol)
        ? state.symbol
        : 'dots';
      const iconRecord = window.SmoofPictogramLibrary?.get?.(symbol);
      const standard = symbol === 'dots';
      const pictogramAspect = standard
        ? 1
        : Math.max(0.18, Math.min(8, numberValue(iconRecord?.aspect) || 1));
      const scale = Math.max(0.1, numberValue(state.scale) || 1);
      const visibleFraction = standard && count < 4
        ? Math.max(0.1, count / 4 - 0.006)
        : 1;
      const visibleWidth = (standard ? 0.1456 * visibleFraction : 0.064 * pictogramAspect) * scale;
      const offsetX = standard && side === 'left' ? 0.1456 * scale - visibleWidth : 0;
      const labelIsVisible = standard && label?.dataset.smoofArrowLabelVisible !== 'false' && getComputedStyle(label).display !== 'none';

      return {
        side,
        x: round((numberValue(state.x) + offsetX) * VIEWBOX_SIZE),
        y: round(numberValue(state.y) * VIEWBOX_SIZE),
        width: round(visibleWidth * VIEWBOX_SIZE),
        height: round((standard
          ? 0.0827 * (labelIsVisible ? 1 : 31.42 / 48.27)
          : 0.064) * scale * VIEWBOX_SIZE),
        visible: graphic.dataset.smoofArrowVisible !== 'false' && getComputedStyle(graphic).display !== 'none',
        labelVisible: labelIsVisible,
        label: window.SmoofArrowLabels?.resolve(state,side),
        rotation: numberValue(state.rotation),
        count,
        scale,
        opacity: layerOpacity(`arrow-${side}`),
        symbol,
        colorize: iconRecord?.raster !== true || state.colorize === true,
        arrowColor:
          graphic.style
            .backgroundColor ||
          cssValue(
            graphic,
            'background-color',
            '#000000'
          ),
        labelColor:
          label?.style
            .backgroundColor ||
          cssValue(
            label,
            'background-color',
            '#000000'
          )
      };
    }).filter(Boolean);
  }

  function readCustomPictograms() {
    return (window.SmoofCustomPictogramTools?.getStates?.() || [])
      .filter(state => state.enabled)
      .map(state => {
        const symbol = window.SmoofPictogramLibrary?.has?.(state.symbol) ? state.symbol : 'dots';
        const iconRecord = window.SmoofPictogramLibrary?.get?.(symbol);
        const sourceAspect = numberValue(iconRecord?.aspect) || (symbol === 'dots' ? 1.7606 : 1);
        const aspect = Math.max(0.18, Math.min(8, symbol === 'dots' ? sourceAspect / (31.42 / 48.27) : sourceAspect));
        const scale = Math.max(0.2, numberValue(state.scale) || 1);
        const height = (symbol === 'dots' ? 0.052 : 0.064) * scale;
        const width = height * aspect;
        return {
          id: state.id,
          side: state.mirrored ? 'right' : 'left',
          x: round((numberValue(state.x) - width / 2) * VIEWBOX_SIZE),
          y: round((numberValue(state.y) - height / 2) * VIEWBOX_SIZE),
          width: round(width * VIEWBOX_SIZE),
          height: round(height * VIEWBOX_SIZE),
          visible: state.visible !== false,
          labelVisible: false,
          rotation: numberValue(state.rotation),
          count: 4,
          scale,
          opacity: Math.max(0.05, Math.min(1, numberValue(state.opacity) || 1)),
          symbol,
          colorize: iconRecord?.raster !== true || state.colorize === true,
          arrowColor: state.color || '#000000',
          labelColor: state.color || '#000000'
        };
      });
  }

  function readLogo(
    stageRect
  ) {
    const frame =
      document.querySelector(
        '[data-smoof-logo-editor-frame]:not([data-smoof-logo-instance])'
      );

    const rect =
      normalizedRect(
        frame,
        stageRect
      );

    if (
      !frame ||
      !rect ||
      frame.style.display ===
        'none'
    ) {
      return {
        visible: false
      };
    }

    const image =
      frame.querySelector('img');

    const placeholder =
      frame.querySelector(
        '[data-smoof-logo-placeholder]'
      );

    return {
      visible: true,
      opacity: layerOpacity('logo'),
      ...rect,
      rotation:
        numberValue(
          propertyValue(
            'properties[_SMOOF Logo Drehung]'
          ),
          0
        ),
      hasLogo:
        frame.dataset.hasLogo ===
          'true' &&
        Boolean(image?.src),
      src:
        image?.src || '',
      fileName:
        propertyValue(
          'properties[_SMOOF Logo Dateiname]'
        ),
      inverted:
        window.SmoofLogoInvertTools?.get?.('logo') ??
        propertyBoolean('properties[_SMOOF Logo invertiert]'),
      background:
        window.SmoofLogoBackgroundTools?.get?.('logo') || null,
      placeholderColor:
        cssValue(
          placeholder,
          'color',
          '#000000'
        )
    };
  }

  function readLogoCopy(
    stageRect
  ) {
    const frame = document.querySelector('[data-smoof-logo-instance="copy"]');
    const toolsState = window.SmoofLogoCopyTools?.getState?.() || {};
    const rect = normalizedRect(frame, stageRect);

    if (!frame || !rect || !toolsState.enabled || !toolsState.visible || frame.style.display === 'none') {
      return { visible: false };
    }

    return {
      visible: true,
      opacity: layerOpacity('logo-copy'),
      ...rect,
      rotation: numberValue(toolsState.rotation),
      hasLogo: Boolean(toolsState.dataUrl || toolsState.src),
      src: toolsState.dataUrl || toolsState.src || '',
      fileName: toolsState.fileName || '',
      inverted:
        window.SmoofLogoInvertTools?.get?.('logo-copy') ??
        propertyBoolean('properties[_SMOOF Logo 1 Duplikat invertiert]'),
      background:
        window.SmoofLogoBackgroundTools?.get?.('logo-copy') || null,
      placeholderColor: '#000000'
    };
  }

  function readLogoDuplicate(
    stageRect
  ) {
    const frame =
      document.querySelector(
        '[data-smoof-logo-instance="2"]'
      );
    const toolsState =
      window.SmoofLogoDuplicateTools
        ?.getState?.() || {};
    const rect = normalizedRect(frame, stageRect);

    if (!frame || !rect || !toolsState.enabled || !toolsState.visible || frame.style.display === 'none') {
      return { visible: false };
    }

    const source = toolsState;

    return {
      visible: true,
      opacity: layerOpacity('logo-2'),
      ...rect,
      rotation: numberValue(toolsState.rotation),
      hasLogo: Boolean(source.dataUrl),
      src: source.dataUrl || '',
      fileName: source.fileName || '',
      inverted:
        window.SmoofLogoInvertTools?.get?.('logo-2') ??
        propertyBoolean('properties[_SMOOF Logo 2 invertiert]'),
      background:
        window.SmoofLogoBackgroundTools?.get?.('logo-2') || null,
      placeholderColor: '#000000'
    };
  }

  function readNumber(
    stageRect
  ) {
    const frame =
      document.querySelector(
        '[data-smoof-number-frame]'
      );

    const content =
      frame?.querySelector(
        '[data-smoof-number-content]'
      );

    const rect =
      normalizedRect(
        content,
        stageRect
      );

    if (
      !frame ||
      !content ||
      !rect ||
      frame.hidden
    ) {
      return {
        visible: false
      };
    }

    const computed =
      getComputedStyle(content);

    const pillElement = frame.querySelector('[data-smoof-number-pill]');
    const pillRect = textPillRect(frame, stageRect);
    const pillStyle = pillElement ? getComputedStyle(pillElement) : null;

    /*
     * Die Nummern-Komponente speichert ihren Mittelpunkt kanonisch als
     * Prozentwerte an `left` und `top`. Produktansichten dürfen den gesamten
     * Overlay-Container visuell skalieren. `getBoundingClientRect()` enthält
     * diese Präsentationsskalierung bereits; würde die daraus gebaute
     * Vektorebene anschließend ebenfalls skaliert, verschöbe sich die Nummer
     * ein zweites Mal in Richtung QR-Code. Deshalb hat die gespeicherte
     * Rahmenposition Vorrang. Für ältere oder fremde Implementierungen ohne
     * Prozentposition bleibt die bisherige DOM-Messung als Fallback erhalten.
     */
    const center =
      positionedFrameCenter(frame) ||
      centerOf(rect);

    return {
      visible: true,
      opacity: layerOpacity('table-number'),
      editing:
        frame.dataset.editing ===
        'true',
      placeholder:
        content.dataset
          .placeholder === 'true',
      value:
        content.textContent || '',
      x: round(center.x),
      y: round(center.y),
      rotation: numberValue(frame.dataset.smoofTextRotation),
      fontFamily:
        firstFontFamily(
          computed.fontFamily
        ),
      fontSize: round(
        numberValue(
          computed.fontSize
        ) /
        stageRect.width *
        VIEWBOX_SIZE
      ),
      fontWeight:
        String(
          computed.fontWeight ||
          '400'
        ),
      fontStyle:
        computed.fontStyle ||
        'normal',
      letterSpacing:
        computed.letterSpacing ===
          'normal'
          ? 0
          : round(
              numberValue(
                computed
                  .letterSpacing
              ) /
              stageRect.width *
              VIEWBOX_SIZE
            ),
      color:
        computed.color ||
        '#000000',
      pill: pillElement && pillRect && pillStyle?.display !== 'none'
        ? {
            visible: true,
            ...pillRect,
            stroke: pillStyle.borderColor || '#000000',
            strokeWidth: round(numberValue(pillStyle.borderWidth) / stageRect.width * VIEWBOX_SIZE),
            fill: pillElement.dataset.smoofPillFillVisible === 'true'
              ? (pillStyle.backgroundColor || '#ffffff')
              : 'none'
          }
        : { visible: false }
    };
  }

  function readBrandDot(
    stageRect
  ) {
    const dot =
      document.querySelector(
        '[data-smoof-brand-dot]'
      );

    const visible =
      window.SmoofBrandTools
        ?.isVisible
        ? window.SmoofBrandTools
            .isVisible()
        : Boolean(
            dot &&
            !dot.hidden
          );

    if (!dot || !visible) {
      return {
        visible: false
      };
    }

    const rect =
      normalizedRect(
        dot,
        stageRect
      );

    if (!rect) {
      return {
        visible: false
      };
    }

    const center =
      centerOf(rect);

    return {
      visible: true,
      opacity: layerOpacity('branding-dot'),
      x: round(center.x),
      y: round(center.y),
      radius: round(
        Math.min(
          rect.width,
          rect.height
        ) / 2
      ),
      color:
        dot.style
          .backgroundColor ||
        cssValue(
          dot,
          'background-color',
          '#000000'
        )
    };
  }

  function readModel() {
    const stage =
      stageElement();

    if (!stage) {
      throw new Error(
        'Live preview unavailable'
      );
    }

    const stageRect =
      stage.getBoundingClientRect();

    if (
      !stageRect.width ||
      !stageRect.height
    ) {
      throw new Error(
        'Live preview has no size'
      );
    }

    const background =
      document.querySelector(
        '[data-smoof-background-color]'
      );

    const bridgedBackgroundImage =
      window
        .SmoofBackgroundImageBridge
        ?.getState?.();

    const backgroundImage =
      (bridgedBackgroundImage?.hasImage
        ? bridgedBackgroundImage
        : window
            .SmoofBackgroundImageTools
            ?.getState?.()) || {
        dataUrl: '',
        fileName: '',
        hasImage: false
      };

    const productVariant =
      window
        .SmoofProductVariant
        ?.get?.() ||
      null;

    const nfcTools =
      window.SmoofNfcTools;

    const nfcState =
      nfcTools?.getState?.() || {};

    const nfcFrame =
      document.querySelector(
        '[data-smoof-nfc-frame]'
      );

    const nfcToolActive =
      typeof nfcTools?.isActive ===
        'function'
        ? Boolean(
            nfcTools.isActive()
          )
        : null;

    const nfcVariantActive =
      typeof productVariant
        ?.nfcEnabled === 'boolean'
        ? productVariant
            .nfcEnabled
        : null;

    const nfcActive =
      nfcVariantActive !== null
        ? nfcVariantActive
        : nfcToolActive !== null
          ? nfcToolActive
          : Boolean(nfcFrame);

    const nfcVisibleState =
      typeof nfcTools?.isVisible ===
        'function'
        ? Boolean(
            nfcTools.isVisible()
          )
        : typeof nfcState.visible ===
            'boolean'
          ? nfcState.visible
          : nfcFrame
            ? !nfcFrame.hidden &&
              getComputedStyle(
                nfcFrame
              ).display !== 'none' &&
              getComputedStyle(
                nfcFrame
              ).visibility !==
                'hidden'
            : true;

    const qrState = window.SmoofQrGeometryTools?.getState?.() || {
      x: 0.5,
      y: 0.5,
      scale: 1,
      visible: true,
      codeColor: '#000000',
      backingVisible:
        qrBackingVisible(),
      backingColor: '#FFFFFF'
    };

    return {
      schema: VERSION,
      formatMm:
        getPrintDiameterMm(),
      productVariant:
        productVariant
          ? {
              schema:
                productVariant
                  .schema ||
                '',
              variantId:
                productVariant
                  .variantId ||
                '',
              nfcEnabled:
                Boolean(
                  productVariant
                    .nfcEnabled
                ),
              nfcCode:
                productVariant
                  .nfcCode ||
                '',
              diameterMm:
                Number(
                  productVariant
                    .diameterMm
                ) || 80,
              materialCode:
                productVariant
                  .materialCode ||
                '',
              printProcess:
                productVariant
                  .printProcess ||
                '',
              woodCode:
                productVariant
                  .woodCode ||
                '',
              designMode:
                productVariant
                  .designMode ||
                ''
            }
          : null,
      nfc: {
        ...nfcState,
        active: nfcActive,
        visible:
          nfcActive &&
          nfcVisibleState,
        x:
          normalizedNfcCoordinate(
            nfcState.x
          ),
        y:
          normalizedNfcCoordinate(
            nfcState.y
          ),
        iconColor:
          nfcState.iconColor ||
          '#1d1d1b',
        circleColor:
          nfcState.circleColor ||
          '#ffffff',
        circleTransparent:
          Boolean(
            nfcState
              .circleTransparent
          ),
        opacity:
          layerOpacity('nfc')
      },
      qr: {
        x: Math.max(0, Math.min(1, Number(qrState.x) || 0.5)),
        y: Math.max(0, Math.min(1, Number(qrState.y) || 0.5)),
        scale: Math.max(0.5, Math.min(1.5, Number(qrState.scale) || 1)),
        visible:
          qrVisible({ qr: qrState }),
        codeColor:
          qrCodeColor({ qr: qrState, productVariant }),
        backingVisible:
          qrBackingVisible({ qr: qrState }),
        backingColor:
          qrBackingColor({ qr: qrState })
      },
      viewBox: {
        width: VIEWBOX_SIZE,
        height: VIEWBOX_SIZE,
        printCircle: {
          cx: 500,
          cy: 500,
          radius: PRINT_RADIUS
        }
      },
      backgroundColor:
        background?.style
          .backgroundColor ||
        cssValue(
          background,
          'background-color',
          '#000000'
        ),
      backgroundOpacity: layerOpacity('background'),
      backgroundGradient:
        window
          .SmoofBackgroundGradientTools
          ?.getState?.() || {
            enabled: false,
            color1: '#000000',
            color2: '#ffffff',
            angle: 0
          },
      backgroundImage,
      texts:
        readTextLines(stageRect),
      arrows:
        [...readArrows(stageRect), ...readCustomPictograms()],
      logo:
        window.SmoofLogoColourTools?.decorate?.('logo', readLogo(stageRect)) || readLogo(stageRect),
      logoCopy:
        window.SmoofLogoColourTools?.decorate?.('logo-copy', readLogoCopy(stageRect)) || readLogoCopy(stageRect),
      logoDuplicate:
        window.SmoofLogoColourTools?.decorate?.('logo-2', readLogoDuplicate(stageRect)) || readLogoDuplicate(stageRect),
      payments: {
        ...(window.SmoofPaymentTools?.getState?.() || {
          selected: [],
          color: '#000000',
          scale: 1,
          x: 0.5,
          y: 0.72,
          visible: true,
          maxWidth: 0.46
        }),
        opacity: layerOpacity('payments')
      },
      socialPlatforms:
        window.SmoofSocialPlatformTools?.getState?.() || { objects: {} },
      number:
        readNumber(stageRect),
      brandDot:
        readBrandDot(stageRect),
      layerOpacity:
        window.SmoofLayerOpacityTools?.getHistoryState?.() || {}
    };
  }

  function createSvgElement(
    name,
    attributes = {}
  ) {
    const element =
      document.createElementNS(
        SVG_NS,
        name
      );

    Object.entries(attributes)
      .forEach(([
        key,
        value
      ]) => {
        if (
          value === null ||
          value === undefined ||
          value === ''
        ) {
          return;
        }

        element.setAttribute(
          key,
          String(value)
        );
      });

    return element;
  }

  function setImageHref(
    image,
    value
  ) {
    image.setAttribute(
      'href',
      value
    );

    image.setAttributeNS(
      XLINK_NS,
      'xlink:href',
      value
    );
  }

  /*
   * Safari kann den Bildinhalt eines SVG-<image> verlieren, wenn der Knoten
   * per cloneNode() aus einem getrennt aufgebauten SVG in die sichtbare
   * Vorschau kopiert wird. Formen wie der optionale Logohintergrund bleiben
   * dabei sichtbar und liegen anschließend scheinbar vor einem fehlenden
   * Logo. Die Live-Vorschau übernimmt ihre fertigen Knoten deshalb direkt.
   * Nach dem Einsetzen werden beide kompatiblen href-Varianten nochmals am
   * tatsächlich verbundenen Bildknoten gesetzt.
   */
  function refreshLiveImageReferences(
    svg
  ) {
    svg.querySelectorAll('image')
      .forEach(image => {
        const value =
          image.getAttribute('href') ||
          image.getAttributeNS(
            XLINK_NS,
            'href'
          ) ||
          image.getAttribute(
            'xlink:href'
          );

        if (!value) return;

        setImageHref(
          image,
          value
        );
      });
  }

  /*
   * Die HTML-Logoebenen sind im Editor bereits korrekt aufgebaut und bilden
   * Logo, Hintergrund und Bedienrahmen gemeinsam ab. Für die Live-Vorschau
   * werden sie deshalb nicht ein zweites Mal als SVG-<image> gezeichnet.
   * Safari verlor bei dieser SVG-Kopie fallweise nur den Bildinhalt, während
   * die Hintergrundform sichtbar blieb. Proof und Produktion verwenden
   * weiterhin den vollständigen SVG-/Canvas-Renderer.
   */
  function setLiveHtmlLogoVisibility(
    visible
  ) {
    document.querySelectorAll(
      '[data-smoof-logo-editor-frame] > img'
    ).forEach(image => {
      if (visible) {
        image.style.setProperty(
          'opacity',
          '1',
          'important'
        );
      } else {
        image.style.removeProperty(
          'opacity'
        );
      }
    });
  }

  let backgroundClipSequence = 0;
  let backgroundGradientSequence = 0;
  let proofQrClipSequence = 0;

  function appendBackgroundGradientDefinition(
    svg,
    model
  ) {
    const gradient =
      model.backgroundGradient;

    if (!gradient?.enabled) return '';

    const angle =
      Number.isFinite(
        Number(gradient.angle)
      )
        ? Number(gradient.angle)
        : 0;

    const radians =
      angle * Math.PI / 180;

    const directionX =
      Math.sin(radians);

    const directionY =
      -Math.cos(radians);

    const lineLength =
      Math.abs(directionX) +
      Math.abs(directionY);

    const halfX =
      directionX * lineLength / 2;

    const halfY =
      directionY * lineLength / 2;

    backgroundGradientSequence += 1;
    const id =
      `smoof-background-gradient-${backgroundGradientSequence}`;

    const defs =
      createSvgElement('defs');

    const linearGradient =
      createSvgElement(
        'linearGradient',
        {
          id,
          x1: 0.5 - halfX,
          y1: 0.5 - halfY,
          x2: 0.5 + halfX,
          y2: 0.5 + halfY,
          gradientUnits:
            'objectBoundingBox'
        }
      );

    linearGradient.append(
      createSvgElement(
        'stop',
        {
          offset: '0%',
          'stop-color':
            gradient.color1 ||
            model.backgroundColor ||
            '#000000'
        }
      ),
      createSvgElement(
        'stop',
        {
          offset: '100%',
          'stop-color':
            gradient.color2 ||
            '#ffffff'
        }
      )
    );

    defs.appendChild(linearGradient);
    svg.appendChild(defs);

    return `url(#${id})`;
  }

  function appendBackgroundImage(
    svg,
    model,
    productionViewBox = null
  ) {
    const source =
      model.backgroundImage?.dataUrl || '';

    if (!source) return;

    const image = createSvgElement(
      'image',
      {
        preserveAspectRatio:
          'xMidYMid slice'
      }
    );

    setImageHref(image, source);

    const positionX = Math.max(0, Math.min(1, Number.isFinite(Number(model.backgroundImage?.positionX)) ? Number(model.backgroundImage.positionX) : 0.5));
    const positionY = Math.max(0, Math.min(1, Number.isFinite(Number(model.backgroundImage?.positionY)) ? Number(model.backgroundImage.positionY) : 0.5));
    const zoom = Math.max(0.05, Math.min(3, Number(model.backgroundImage?.scale) || 1));
    const baseBox = productionViewBox
      ? { x: productionViewBox.x, y: productionViewBox.y, size: productionViewBox.size }
      : { x: 500 - PRINT_RADIUS, y: 500 - PRINT_RADIUS, size: PRINT_RADIUS * 2 };
    const imageSize = baseBox.size * zoom;
    image.setAttribute('x', baseBox.x - (imageSize - baseBox.size) * positionX);
    image.setAttribute('y', baseBox.y - (imageSize - baseBox.size) * positionY);
    image.setAttribute('width', imageSize);
    image.setAttribute('height', imageSize);

    if (productionViewBox) {
      svg.appendChild(image);
      return;
    }

    backgroundClipSequence += 1;
    const clipId =
      `smoof-background-clip-${backgroundClipSequence}`;
    const defs =
      createSvgElement('defs');
    const clip =
      createSvgElement(
        'clipPath',
        { id: clipId }
      );

    clip.appendChild(
      createSvgElement(
        'circle',
        {
          cx: 500,
          cy: 500,
          r: PRINT_RADIUS
        }
      )
    );
    defs.appendChild(clip);
    svg.appendChild(defs);

    image.setAttribute(
      'clip-path',
      `url(#${clipId})`
    );
    svg.appendChild(image);
  }

  function appendBackgroundOverlay(svg, model, productionViewBox = null) {
    const overlay = model.backgroundGradient;
    const opacity = Math.max(0, Math.min(1, Number(overlay?.overlayOpacity) || 0));
    if (!overlay?.overlayEnabled || opacity <= 0) return;
    const attributes = productionViewBox
      ? {
          x: productionViewBox.x,
          y: productionViewBox.y,
          width: productionViewBox.size,
          height: productionViewBox.size
        }
      : {
          cx: 500,
          cy: 500,
          r: PRINT_RADIUS
        };
    svg.appendChild(createSvgElement(productionViewBox ? 'rect' : 'circle', {
      ...attributes,
      fill: overlay.overlayColor || '#000000',
      'fill-opacity': opacity
    }));
  }

  function recolorSvgGroup(
    group,
    color
  ) {
    group
      .querySelectorAll(
        [
          'path',
          'circle',
          'ellipse',
          'rect',
          'polygon',
          'polyline',
          'line',
          'text',
          'tspan'
        ].join(',')
      )
      .forEach(element => {
        element.removeAttribute(
          'class'
        );

        element.setAttribute(
          'fill',
          color
        );

        element.style.setProperty(
          'fill',
          color,
          'important'
        );
      });
  }

  async function loadArrowAsset(
    side
  ) {
    if (
      arrowAssetCache.has(side)
    ) {
      return arrowAssetCache.get(
        side
      );
    }

    const promise =
      requestResource(
        ARROW_URLS[side]
      ).then(async response => {
        const source =
          response.body;

        const documentSvg =
          new DOMParser()
            .parseFromString(
              source,
              'image/svg+xml'
            );

        const svg =
          documentSvg.documentElement;

        const groups =
          Array.from(
            svg.children
          ).filter(child =>
            child.tagName
              .toLowerCase() === 'g'
          );

        if (
          svg.tagName
            .toLowerCase() !==
              'svg' ||
          groups.length < 2
        ) {
          throw new Error(
            'Invalid arrow SVG structure'
          );
        }

        return {
          viewBox:
            svg.getAttribute(
              'viewBox'
            ) ||
            '0 0 85.01 48.27',
          arrow:
            groups[0],
          label:
            groups[1]
        };
      });

    arrowAssetCache.set(
      side,
      promise
    );

    return promise;
  }

  function isNfcEnabled(model) {
    return Boolean(
      model.nfc?.active ??
      model.productVariant
        ?.nfcEnabled
    ) &&
      model.nfc?.visible !== false;
  }

  function nfcCenter(model) {
    return {
      x:
        normalizedNfcCoordinate(
          model.nfc?.x
        ) *
        VIEWBOX_SIZE,
      y:
        normalizedNfcCoordinate(
          model.nfc?.y
        ) *
        VIEWBOX_SIZE
    };
  }

  function appendNfcIcon(
    svg,
    model
  ) {
    if (!isNfcEnabled(model)) {
      return;
    }

    const center =
      nfcCenter(model);

    const size =
      NFC_ICON_BOX.size *
      Math.max(0.1, Math.min(4, Number(model.nfc?.scale) || 1));

    const scale =
      size /
      NFC_VIEWBOX_SIZE;

    const group =
      createSvgElement(
        'g',
        {
          transform: [
            `translate(${center.x - size / 2} ${center.y - size / 2})`,
            `scale(${scale})`
          ].join(' '),
          opacity:
            model.nfc?.opacity ??
            model.layerOpacity?.nfc ??
            layerOpacity('nfc'),
          'data-smoof-vector-nfc':
            'true'
        }
      );

    if (
      !model.nfc
        ?.circleTransparent
    ) {
      group.appendChild(
        createSvgElement(
          'circle',
          {
            cx:
              NFC_VIEWBOX_SIZE /
              2,
            cy:
              NFC_VIEWBOX_SIZE /
              2,
            r:
              NFC_VIEWBOX_SIZE /
              2,
            fill:
              model.nfc
                ?.circleColor ||
              '#ffffff'
          }
        )
      );
    }

    NFC_ICON_PATHS.forEach(
      pathData => {
        group.appendChild(
          createSvgElement(
            'path',
            {
              d: pathData,
              fill:
                model.nfc
                  ?.iconColor ||
                '#1d1d1b'
            }
          )
        );
      }
    );

    svg.appendChild(group);
  }

  function drawCanvasNfc(
    context,
    model
  ) {
    if (!isNfcEnabled(model)) {
      return;
    }

    const center =
      nfcCenter(model);

    const size =
      NFC_ICON_BOX.size *
      Math.max(0.1, Math.min(4, Number(model.nfc?.scale) || 1));

    const scale =
      size /
      NFC_VIEWBOX_SIZE;

    context.save();
    context.globalAlpha =
      model.nfc?.opacity ??
      model.layerOpacity?.nfc ??
      1;
    context.translate(
      center.x -
        size / 2,
      center.y -
        size / 2
    );
    context.scale(scale, scale);

    if (
      !model.nfc
        ?.circleTransparent
    ) {
      context.beginPath();
      context.arc(
        NFC_VIEWBOX_SIZE / 2,
        NFC_VIEWBOX_SIZE / 2,
        NFC_VIEWBOX_SIZE / 2,
        0,
        Math.PI * 2
      );
      context.fillStyle =
        model.nfc?.circleColor ||
        '#ffffff';
      context.fill();
    }

    context.fillStyle =
      model.nfc?.iconColor ||
      '#1d1d1b';

    if (
      typeof Path2D ===
      'function'
    ) {
      NFC_ICON_PATHS.forEach(
        pathData => {
          context.fill(
            new Path2D(pathData)
          );
        }
      );
    } else {
      context.lineWidth = 5;
      context.lineCap = 'round';
      context.strokeStyle =
        context.fillStyle;

      [18, 27, 36].forEach(
        radius => {
          context.beginPath();
          context.arc(
            NFC_VIEWBOX_SIZE / 2,
            53,
            radius,
            Math.PI * 1.2,
            Math.PI * 1.8
          );
          context.stroke();
        }
      );

      context.font =
        '700 20px Arial, sans-serif';
      context.textAlign = 'center';
      context.textBaseline =
        'middle';
      context.fillText(
        'NFC',
        NFC_VIEWBOX_SIZE / 2,
        79
      );
    }

    context.restore();
  }

  function appendText(
    svg,
    item,
    extra = {}
  ) {
    if (
      !item?.visible ||
      !item.value
    ) {
      return;
    }

    if(item.curved){window.SmoofCurvedText.append(svg,item);return;}
    if((item.runs?.length || ['left','right','justify'].includes(item.textAlign)) && window.SmoofRichText) {
      const group=createSvgElement('g',{transform:`rotate(${Number(item.rotation)||0} ${item.x} ${item.y})`});svg.appendChild(group);
      if(item.pill?.visible)appendText(group,{...item,runs:null,textAlign:'center',value:' ',rotation:0},extra);
      for(const line of window.SmoofRichText.layout(item))for(const part of line.parts)appendText(group,{...part,pill:null,rotation:0},extra);
      return;
    }
    const group = createSvgElement('g', {
      transform: `rotate(${Number(item.rotation) || 0} ${item.x} ${item.y})`
    });
    svg.appendChild(group);
    if (item.pill?.visible) {
      const pill = item.pill;
      group.appendChild(createSvgElement('rect', {
        x: pill.x,
        y: pill.y,
        width: pill.width,
        height: pill.height,
        rx: pill.height / 2,
        ry: pill.height / 2,
        fill: pill.fill || 'none',
        stroke: pill.stroke || '#000000',
        'stroke-width': pill.strokeWidth || 1,
        opacity: item.opacity ?? 1
      }));
    }

    const text =
      createSvgElement(
        'text',
        {
          x: item.x,
          y:
            item.y +
            (
              IS_SAFARI
                ? Number(item.fontSize) *
                  SAFARI_TEXT_BASELINE_OFFSET_EM
                : 0
            ),
          fill:
            item.color ||
            '#000000',
          'font-family':
            item.fontFamily ||
            'Arial',
          'font-size':
            item.fontSize,
          'font-weight':
            item.fontWeight ||
            '400',
          'font-style':
            item.fontStyle ||
            'normal',
          'letter-spacing':
            item.letterSpacing ||
            0,
          'text-anchor':
            'middle',
          'dominant-baseline':
            'central',
          'data-smoof-text-rendered':
            String(item.index),
          opacity:
            (item.opacity ?? 1) *
            (extra.opacity ?? 1)
        }
      );

    text.style.fontSynthesis =
      window.SmoofCustomFontRegistry
        ?.isCustomFamily?.(item.fontFamily)
        ? 'none'
        : 'weight style';

    text.style.textRendering =
      'geometricPrecision';

    const lines = String(item.value).replace(/\r\n?/g, '\n').split('\n');
    const lineHeight = Number(item.lineHeight) || Number(item.fontSize) * 1.08;

    lines.forEach((line, index) => {
      const tspan = createSvgElement('tspan', {
        x: item.x,
        dy: index === 0
          ? -((lines.length - 1) * lineHeight) / 2
          : lineHeight
      });
      tspan.textContent = line || ' ';
      text.appendChild(tspan);
    });

    group.appendChild(text);
  }

  function appendProofTrimGuide(svg) {
    const group = createSvgElement(
      'g',
      {
        'data-smoof-proof-trim-guide':
          'true',
        'aria-label':
          'Endformat - nur Hilfslinie'
      }
    );

    const guideAttributes = {
      cx: 500,
      cy: 500,
      fill: 'none',
      'stroke-dasharray': '12 8',
      'stroke-linecap': 'butt'
    };

    /* Weiße Unterlegung plus dunkle Decklinie bleibt auf hellen und dunklen
     * Motiven sichtbar, ohne wie ein Bestandteil des Designs zu wirken. */
    group.append(
      createSvgElement(
        'circle',
        {
          ...guideAttributes,
          r:
            PRINT_RADIUS +
            PROOF_TRIM_GUIDE_WHITE_OFFSET,
          stroke: '#ffffff',
          'stroke-width': 7,
          opacity: 0.92
        }
      ),
      createSvgElement(
        'circle',
        {
          ...guideAttributes,
          r:
            PRINT_RADIUS +
            PROOF_TRIM_GUIDE_DARK_OFFSET,
          stroke: '#263238',
          'stroke-width': 2.4,
          opacity: 0.92
        }
      )
    );

    const legend = createSvgElement(
      'g',
      {
        'data-smoof-proof-trim-legend':
          'true'
      }
    );

    const sampleAttributes = {
      x1: 220,
      y1: 900,
      x2: 300,
      y2: 900,
      'stroke-dasharray': '10 7',
      'stroke-linecap': 'butt'
    };

    legend.append(
      createSvgElement(
        'line',
        {
          ...sampleAttributes,
          stroke: '#ffffff',
          'stroke-width': 7
        }
      ),
      createSvgElement(
        'line',
        {
          ...sampleAttributes,
          stroke: '#263238',
          'stroke-width': 2.4
        }
      )
    );

    const label = createSvgElement(
      'text',
      {
        x: 320,
        y: 900,
        fill: '#263238',
        'font-family':
          'Arial, Helvetica, sans-serif',
        'font-size': 18,
        'font-weight': 600,
        'dominant-baseline':
          'central',
        'text-anchor': 'start'
      }
    );

    label.textContent =
      window.SmoofI18n.legacy('Endformat - nur Hilfslinie, wird nicht gedruckt');

    legend.appendChild(label);
    group.appendChild(legend);
    svg.appendChild(group);
  }

  function recolorPictogram(
    group,
    color
  ) {
    [group, ...group.querySelectorAll('*')]
      .forEach(element => {
        const stroke = element.getAttribute?.('stroke');
        const fill = element.getAttribute?.('fill');
        if (stroke && stroke !== 'none') {
          element.setAttribute('stroke', color);
          element.style?.setProperty('stroke', color, 'important');
        }
        if (fill && fill !== 'none') {
          element.setAttribute('fill', color);
          element.style?.setProperty('fill', color, 'important');
        } else if (fill == null && /^(path|rect|circle|ellipse|polygon|polyline)$/i.test(element.localName || '')) {
          let ancestor = element.parentElement;
          let inheritedFill = '';
          while (ancestor && ancestor !== group.parentElement) {
            if (ancestor.hasAttribute?.('fill')) {
              inheritedFill = ancestor.getAttribute('fill') || '';
              break;
            }
            ancestor = ancestor.parentElement;
          }
          if (inheritedFill !== 'none') {
            element.setAttribute('fill', color);
            element.style?.setProperty('fill', color, 'important');
          }
        }
      });
  }

  async function appendPictogram(
    svg,
    item
  ) {
    const source = await (
      window.SmoofPictogramLibrary
        ?.loadSvg?.(item.symbol, item.side, { colorize: item.colorize }) ||
      Promise.resolve(window.SmoofPictogramLibrary?.svg?.(item.symbol, item.side, { colorize: item.colorize }))
    );

    if (!source) return;

    const documentSvg =
      new DOMParser().parseFromString(
        source,
        'image/svg+xml'
      );

    const sourceGroup =
      documentSvg.documentElement
        .querySelector('g');

    const sourceViewBox =
      documentSvg.documentElement
        .getAttribute('viewBox') ||
      '0 0 100 100';

    if (!sourceGroup) return;

    const nested =
      createSvgElement(
        'svg',
        {
          'data-smoof-pictogram-rendered': item.symbol,
          'data-smoof-pictogram-side': item.side,
          x: item.x,
          y: item.y,
          width: item.width,
          height: item.height,
          viewBox: sourceViewBox,
          preserveAspectRatio: 'xMidYMid meet',
          overflow: 'visible'
        }
      );

    const icon =
      sourceGroup.cloneNode(true);

    if (item.colorize !== false) {
      recolorPictogram(
        icon,
        item.arrowColor || '#000000'
      );
    }

    nested.appendChild(icon);

    const rotatedGroup =
      createSvgElement(
        'g',
        {
          transform:
            `rotate(${item.rotation || 0} ${item.x + item.width / 2} ${item.y + item.height / 2})`,
          opacity: item.opacity ?? 1
        }
      );

    rotatedGroup.appendChild(nested);
    svg.appendChild(rotatedGroup);
  }

  async function appendArrows(
    svg,
    arrows
  ) {
    await Promise.all(
      arrows.map(async item => {
        if (!item.visible) return;
        if (item.symbol && item.symbol !== 'dots') {
          await appendPictogram(svg, item);
          return;
        }
        const asset =
          await loadArrowAsset(
            item.side
          );

        const assetViewBox = String(asset.viewBox).trim().split(/\s+/).map(Number);
        const assetX = assetViewBox[0] || 0;
        const assetY = assetViewBox[1] || 0;
        const assetWidth = assetViewBox[2] || 85.01;
        const assetHeight = item.label && !item.label.legacy ? 48.27 : assetViewBox[3] || 48.3;
        const cropFraction = item.count >= 4
          ? 1
          : Math.max(0.1, item.count / 4 - 0.006);
        const cropWidth = assetWidth * cropFraction;
        const cropX = item.side === 'left'
          ? assetX + assetWidth - cropWidth
          : assetX;
        const visibleHeight = item.labelVisible ? assetHeight : Math.min(assetHeight, 31.42);
        const visibleViewBox = `${cropX} ${assetY} ${cropWidth} ${visibleHeight}`;

        const nested =
          createSvgElement(
            'svg',
            {
              x: item.x,
              y: item.y,
              width: item.width,
              height: item.height,
              viewBox:
                visibleViewBox,
              preserveAspectRatio:
                'xMidYMid meet',
              overflow: 'hidden'
            }
          );

        nested.style.overflow = 'hidden';

        const rotatedGroup =
          createSvgElement(
            'g',
            {
              transform:
                `rotate(${item.rotation || 0} ${item.x + item.width / 2} ${item.y + item.height / 2})`,
              opacity: item.opacity ?? 1
            }
          );

        const arrow =
          asset.arrow.cloneNode(
            true
          );

        const label = item.labelVisible && item.label && !item.label.legacy
          ? new DOMParser().parseFromString(await window.SmoofArrowLabels.source(item.label,item.count),'image/svg+xml').documentElement.querySelector('g') || createSvgElement('g')
          : asset.label.cloneNode(true);

        recolorSvgGroup(
          arrow,
          item.arrowColor ||
          '#000000'
        );
        const labelPosition=createSvgElement('g',{transform:`translate(${cropX + cropWidth / 2 - (assetX + assetWidth / 2)} 0)`});
        labelPosition.appendChild(label);

        recolorSvgGroup(
          label,
          item.labelColor ||
          '#000000'
        );

        nested.appendChild(arrow);
        if (item.labelVisible) nested.appendChild(labelPosition);

        rotatedGroup.appendChild(nested);
        svg.appendChild(rotatedGroup);
      })
    );
  }

  function ensureLogoInvertFilter(svg) {
    const filterId = 'smoof-logo-colour-invert';
    if (svg.querySelector(`#${filterId}`)) return filterId;
    let defs = svg.querySelector('defs');
    if (!defs) {
      defs = createSvgElement('defs');
      svg.insertBefore(defs, svg.firstChild);
    }
    const filter = createSvgElement('filter', {
      id: filterId,
      x: '-5%',
      y: '-5%',
      width: '110%',
      height: '110%',
      'color-interpolation-filters': 'sRGB'
    });
    const transfer = createSvgElement('feComponentTransfer');
    ['R', 'G', 'B'].forEach(channel => {
      transfer.appendChild(createSvgElement(`feFunc${channel}`, {
        type: 'linear',
        slope: -1,
        intercept: 1
      }));
    });
    transfer.appendChild(createSvgElement('feFuncA', {
      type: 'identity'
    }));
    filter.appendChild(transfer);
    defs.appendChild(filter);
    return filterId;
  }

  function appendLogo(
    svg,
    logo
  ) {
    if (!logo?.visible) return;

    const group =
      createSvgElement(
        'g',
        {
          transform:
            `rotate(${logo.rotation || 0} ${
              logo.x +
              logo.width / 2
            } ${
              logo.y +
              logo.height / 2
            })`,
          opacity: logo.opacity ?? 1
        }
      );

    if (
      logo.hasLogo &&
      logo.src
    ) {
      appendLogoBackground(group, logo);
      const image =
        createSvgElement(
          'image',
          {
            x: logo.x,
            y: logo.y,
            width: logo.width,
            height: logo.height,
            preserveAspectRatio:
              'xMidYMid meet'
          }
        );

      setImageHref(
        image,
        logo.src
      );

      if (logo.inverted) {
        image.setAttribute('filter', `url(#${ensureLogoInvertFilter(svg)})`);
      }

      group.appendChild(image);
    } else {
      const color =
        logo.placeholderColor ||
        '#000000';

      group.appendChild(
        createSvgElement(
          'rect',
          {
            x: logo.x + 2,
            y: logo.y + 2,
            width:
              Math.max(
                0,
                logo.width - 4
              ),
            height:
              Math.max(
                0,
                logo.height - 4
              ),
            rx: 7,
            fill: 'none',
            stroke: color,
            'stroke-width': 1.6,
            'stroke-dasharray':
              '6 5',
            opacity: 0.72
          }
        )
      );

      const label =
        createSvgElement(
          'text',
          {
            x:
              logo.x +
              logo.width / 2,
            y:
              logo.y +
              logo.height / 2,
            fill: color,
            'font-family': 'Arial',
            'font-size':
              clamp(
                logo.height * 0.3,
                12,
                24
              ),
            'font-weight': '700',
            'letter-spacing': 1.4,
            'text-anchor': 'middle',
            'dominant-baseline':
              'central',
            opacity: 0.72
          }
        );

      label.textContent = 'LOGO';
      group.appendChild(label);
    }

    svg.appendChild(group);
  }

  function logoBackgroundBox(logo) {
    const background = logo?.background;
    if (!background?.enabled) return null;
    const padding = Math.max(0, Number(background.padding) || 0) * Math.min(logo.width, logo.height);
    let x = logo.x - padding;
    let y = logo.y - padding;
    let width = logo.width + padding * 2;
    let height = logo.height + padding * 2;
    if (background.shape === 'circle') {
      const side = Math.max(logo.width, logo.height) + padding * 2;
      x = logo.x + (logo.width - side) / 2;
      y = logo.y + (logo.height - side) / 2;
      width = side;
      height = side;
    }
    return {
      x,
      y,
      width,
      height,
      shape: background.shape || 'rounded',
      color: /^#[0-9a-f]{6}$/i.test(String(background.color || '')) ? background.color : '#ffffff'
    };
  }

  function appendLogoBackground(group, logo) {
    const box = logoBackgroundBox(logo);
    if (!box) return;
    if (box.shape === 'circle') {
      group.appendChild(createSvgElement('circle', {
        cx: box.x + box.width / 2,
        cy: box.y + box.height / 2,
        r: box.width / 2,
        fill: box.color
      }));
      return;
    }
    group.appendChild(createSvgElement('rect', {
      x: box.x,
      y: box.y,
      width: box.width,
      height: box.height,
      rx: box.shape === 'rounded' ? Math.min(box.width, box.height) * 0.25 : 0,
      fill: box.color
    }));
  }

  function appendPayments(
    svg,
    payments
  ) {
    if (
      !payments?.visible ||
      !payments.selected?.length
    ) {
      return;
    }

    const library =
      window.SmoofPaymentProviderLibrary;
    const geometry = library?.layout?.(payments);
    if (!geometry?.rows.length) return;
    const { scale, gap, itemHeight, rows } = geometry;

    const group = createSvgElement('g', {
      'data-smoof-payment-group-rendered': 'true',
      opacity: payments.opacity ?? 1
    });
    const totalHeight =
      rows.length * itemHeight +
      Math.max(0, rows.length - 1) * gap;
    const centerX =
      clamp(Number(payments.x) || 0.5, 0, 1) * VIEWBOX_SIZE;
    const centerY =
      clamp(Number(payments.y) || 0.72, 0, 1) * VIEWBOX_SIZE;
    let y = centerY - totalHeight / 2;

    rows.forEach(row => {
      let x = centerX - row.width / 2;
      row.items.forEach(({ provider: sourceProvider, width }) => {
        const provider = window.SmoofBrandArtwork?.resolve(sourceProvider, payments) || sourceProvider;
        const item = createSvgElement('g', {
          'data-smoof-payment-provider-rendered': provider.id
        });
        const color = payments.color || '#000000';
        if (provider.artwork) {
          const brandSvg = window.SmoofBrandArtwork.create(provider, payments);
          Object.entries({ x, y, width, height:itemHeight, overflow:'visible', 'aria-label':provider.label }).forEach(([key,value]) => brandSvg.setAttribute(key,value));
          item.appendChild(brandSvg);
        } else if (provider.path) {
          const brandSvg = createSvgElement('svg', {
            x,
            y,
            width,
            height: itemHeight,
            viewBox: provider.viewBox || '0 0 24 24',
            preserveAspectRatio: 'xMidYMid meet',
            overflow: 'visible',
            'aria-label': provider.label
          });
          brandSvg.appendChild(createSvgElement('path', {
            d: provider.path,
            'fill-rule': provider.fillRule || 'nonzero',
            fill: color
          }));
          item.appendChild(brandSvg);
        } else if (provider.id === 'amex') {
          item.appendChild(createSvgElement('rect', {
            x: x + 1,
            y: y + 2,
            width: width - 2,
            height: itemHeight - 4,
            rx: 2,
            fill: 'none',
            stroke: color,
            'stroke-width': 1.5 * scale
          }));
          ['AMERICAN', 'EXPRESS'].forEach((line, index) => {
            const text = createSvgElement('text', {
              x: x + width / 2,
              y: y + itemHeight * (index ? 0.63 : 0.37),
              fill: color,
              'font-family': 'Arial, Helvetica, sans-serif',
              'font-size': 8 * scale,
              'font-weight': 800,
              'text-anchor': 'middle',
              'dominant-baseline': 'central'
            });
            text.textContent = line;
            item.appendChild(text);
          });
        } else {
          const text = createSvgElement('text', {
            x: x + width / 2,
            y: y + itemHeight / 2,
            fill: color,
            'font-family': 'Arial, Helvetica, sans-serif',
            'font-size': 16 * scale,
            'font-weight': provider.weight || 700,
            'font-style': provider.italic ? 'italic' : 'normal',
            'text-anchor': 'middle',
            'dominant-baseline': 'central'
          });
          text.textContent = provider.label;
          item.appendChild(text);
        }
        group.appendChild(item);
        x += width + gap;
      });
      y += itemHeight + gap;
    });

    svg.appendChild(group);
  }

  function appendSocialPlatforms(svg, socialPlatforms) {
    const objects = socialPlatforms?.objects || {};
    const library = window.SmoofSocialPlatformLibrary;
    Object.entries(objects).forEach(([id, object]) => {
      const sourceDefinition = library?.get?.(id);
      const definition = window.SmoofBrandArtwork?.resolve(sourceDefinition, object) || sourceDefinition;
      if (!definition || object?.visible === false || (!definition.path && !definition.artwork)) return;
      const scale = clamp(Number(object.scale) || 1, 0.45, 5);
      const size = 70 * scale;
      const centerX = clamp(Number(object.x) || 0.5, 0, 1) * VIEWBOX_SIZE;
      const centerY = clamp(Number(object.y) || 0.72, 0, 1) * VIEWBOX_SIZE;
      const brandSvg = createSvgElement('svg', {
        x: centerX - size / 2,
        y: centerY - size / 2,
        width: size,
        height: size,
        viewBox: definition.viewBox || '0 0 24 24',
        preserveAspectRatio: 'xMidYMid meet',
        overflow: 'visible',
        opacity: clamp(object.opacity ?? 1, 0, 1),
        'aria-label': definition.label,
        'data-smoof-social-platform-rendered': id
      });
      if (definition.artwork) {
        const original = window.SmoofBrandArtwork.create(definition, object);
        original.setAttribute('width','100%'); original.setAttribute('height','100%');
        brandSvg.appendChild(original);
      } else brandSvg.appendChild(createSvgElement('path', {
        d: definition.path,
        fill: object.color || '#000000'
      }));
      svg.appendChild(brandSvg);
    });
  }

  function appendQrWhitePanel(
    svg,
    model = null
  ) {
    if (!qrBackingVisible(model)) {
      return;
    }

    const panel = qrPanel(model);
    svg.appendChild(
      createSvgElement(
        'rect',
        {
          x: panel.x,
          y: panel.y,
          width: panel.width,
          height: panel.height,
          rx: panel.radius,
          fill: qrBackingColor(model),
          'data-smoof-qr-backing': 'true'
        }
      )
    );
  }

  async function editorQrDataUrl() {
    if (editorQrAssetPromise) {
      return editorQrAssetPromise;
    }

    editorQrAssetPromise =
      requestResource(
        EDITOR_QR_URL,
        'arrayBuffer'
      ).then(resource => (
        'data:image/png;base64,' +
        arrayBufferToBase64(
          resource.body
        )
      )).catch(error => {
        editorQrAssetPromise = null;
        throw error;
      });

    return editorQrAssetPromise;
  }

  async function appendProofEditorQr(svg, model = null) {
    const panel = qrPanel(model);
    appendQrWhitePanel(svg, model);

    if (!qrVisible(model)) {
      return;
    }

    const source =
      await editorQrDataUrl();

    proofQrClipSequence += 1;
    const clipId =
      `smoof-proof-qr-clip-${proofQrClipSequence}`;
    const colorFilterId =
      `smoof-proof-qr-color-${proofQrClipSequence}`;
    const definitions =
      createSvgElement('defs');
    const clip = createSvgElement(
      'clipPath',
      { id: clipId }
    );

    clip.appendChild(
      createSvgElement(
        'rect',
        {
          x: panel.x,
          y: panel.y,
          width: panel.width,
          height: panel.height,
          rx: panel.radius
        }
      )
    );
    definitions.appendChild(clip);
    const colorFilter = createSvgElement('filter', {
      id: colorFilterId,
      x: '-5%',
      y: '-5%',
      width: '110%',
      height: '110%',
      'color-interpolation-filters': 'sRGB'
    });
    colorFilter.appendChild(createSvgElement('feFlood', {
      'flood-color': qrCodeColor(model),
      result: 'qr-colour'
    }));
    colorFilter.appendChild(createSvgElement('feComposite', {
      in: 'qr-colour',
      in2: 'SourceAlpha',
      operator: 'in'
    }));
    definitions.appendChild(colorFilter);
    svg.appendChild(definitions);

    const image = createSvgElement(
      'image',
      {
        x: panel.x - QR_PANEL.x * panel.scale,
        y: panel.y - QR_PANEL.y * panel.scale,
        width: VIEWBOX_SIZE * panel.scale,
        height: VIEWBOX_SIZE * panel.scale,
        preserveAspectRatio: 'none',
        'clip-path': `url(#${clipId})`,
        filter: `url(#${colorFilterId})`,
        'data-smoof-proof-editor-qr':
          'true'
      }
    );

    setImageHref(image, source);
    svg.appendChild(image);
  }

  async function buildSvg(
    model,
    {
      proof = false,
      includeProofTrimGuide = true,
      productionViewBox = null,
      embeddedFontCss = '',
      includeBackground = true,
      includeEditableText = true,
      includeUploadedLogo = true,
      includeLogoPlaceholder = true,
      includeBrandDot = true,
      includeProofEditorQr = true,
      includeNfcIcon = true
    } = {}
  ) {
    if(includeEditableText&&window.SmoofCurvedText)model=await window.SmoofCurvedText.prepare(model);
    const outputViewBox =
      productionViewBox
        ? [
            productionViewBox.x,
            productionViewBox.y,
            productionViewBox.size,
            productionViewBox.size
          ].join(' ')
        : `0 0 ${VIEWBOX_SIZE} ${VIEWBOX_SIZE}`;

    const svg =
      createSvgElement(
        'svg',
        {
          xmlns: SVG_NS,
          'xmlns:xlink':
            XLINK_NS,
          viewBox:
            outputViewBox,
          preserveAspectRatio:
            'xMidYMid meet',
          role: proof
            ? 'img'
            : 'presentation'
        }
      );

    if (embeddedFontCss) {
      const defs =
        createSvgElement('defs');

      const style =
        createSvgElement(
          'style',
          {
            type: 'text/css'
          }
        );

      style.textContent =
        embeddedFontCss;

      defs.appendChild(style);
      svg.appendChild(defs);
    }

    const backgroundFill =
      includeBackground
        ? appendBackgroundGradientDefinition(
            svg,
            model
          ) ||
          model.backgroundColor ||
          '#000000'
        : 'none';
    const backgroundOpacity =
      includeBackground
        ? Math.max(0, Math.min(1, Number(model.backgroundOpacity) || 1))
        : 1;

    if (includeBackground && productionViewBox) {
      svg.appendChild(
        createSvgElement(
          'rect',
          {
            x:
              productionViewBox.x,
            y:
              productionViewBox.y,
            width:
              productionViewBox.size,
            height:
              productionViewBox.size,
            fill: backgroundFill,
            'fill-opacity': backgroundOpacity
          }
        )
      );

    } else if (includeBackground && proof) {
      svg.appendChild(
        createSvgElement(
          'rect',
          {
            x: 0,
            y: 0,
            width: VIEWBOX_SIZE,
            height: VIEWBOX_SIZE,
            fill: '#ffffff'
          }
        )
      );

      svg.appendChild(
        createSvgElement(
          'circle',
          {
            cx: 500,
            cy: 500,
            r: PRINT_RADIUS,
            fill: backgroundFill,
            'fill-opacity': backgroundOpacity
          }
        )
      );

    }

    /*
     * In der Live-Ansicht liegt das echte QR-Canvas
     * unter der SVG-Vorschau. Das Hintergrundbild wird
     * dort bereits von der Hintergrund-Ebene angezeigt.
     * Würden wir es zusätzlich ins Live-SVG zeichnen,
     * würde es den QR-Code überdecken. In Freigabe- und
     * Produktionsdateien gehört es dagegen ins SVG.
     */
    if (
      includeBackground &&
      (proof || productionViewBox)
    ) {
      appendBackgroundImage(
        svg,
        model,
        productionViewBox
      );
      appendBackgroundOverlay(
        svg,
        model,
        productionViewBox
      );
    }

    if (productionViewBox) {
      appendQrWhitePanel(svg, model);
    } else if (
      proof &&
      includeProofEditorQr
    ) {
      await appendProofEditorQr(svg, model);
    }

    if (includeNfcIcon) {
      await appendNfcIcon(
        svg,
        model
      );
    }

    await appendArrows(
      svg,
      model.arrows || []
    );

    if (includeEditableText) {
      (model.texts || [])
        .forEach(item => {
          // Bei der Inline-Bearbeitung zeichnet das echte contenteditable-
          // Element. Das SVG darf denselben Text nicht ein zweites Mal zeigen.
          if (
            proof ||
            !item.editing ||
            !String(item.id || '').startsWith('custom-text-')
          ) {
            appendText(
              svg,
              item
            );
          }
        });
    }

    if (
      (
        includeUploadedLogo &&
        model.logo?.hasLogo
      ) ||
      (
        includeLogoPlaceholder &&
        !model.logo?.hasLogo
      )
    ) {
      appendLogo(
        svg,
        model.logo
      );
    }

    if (
      includeUploadedLogo &&
      model.logoCopy?.hasLogo
    ) {
      appendLogo(
        svg,
        model.logoCopy
      );
    }

    if (
      includeUploadedLogo &&
      model.logoDuplicate?.hasLogo
    ) {
      appendLogo(
        svg,
        model.logoDuplicate
      );
    }

    appendPayments(
      svg,
      model.payments
    );

    appendSocialPlatforms(
      svg,
      model.socialPlatforms
    );

    if (includeEditableText) {
      if (
        proof ||
        !model.number
          ?.editing
      ) {
        appendText(
          svg,
          model.number,
          {
            opacity: 1
          }
        );
      }
    }

    if (
      includeBrandDot &&
      model.brandDot?.visible
    ) {
      svg.appendChild(
        createSvgElement(
          'circle',
          {
            cx:
              model.brandDot.x,
            cy:
              model.brandDot.y,
            r:
              model.brandDot.radius,
            fill:
              model.brandDot.color ||
              '#000000',
            opacity: model.brandDot.opacity ?? 1
          }
        )
      );
    }

    if (
      proof &&
      includeProofTrimGuide
    ) {
      appendProofTrimGuide(svg);
    }

    return svg;
  }

  function arrayBufferToBase64(
    buffer
  ) {
    const bytes =
      new Uint8Array(buffer);

    const chunkSize = 0x8000;
    let binary = '';

    for (
      let offset = 0;
      offset < bytes.length;
      offset += chunkSize
    ) {
      binary +=
        String.fromCharCode(
          ...bytes.subarray(
            offset,
            offset + chunkSize
          )
        );
    }

    return btoa(binary);
  }

  function inferredImageType(
    source
  ) {
    const cleanSource =
      String(source)
        .split('?')[0]
        .toLowerCase();

    if (
      cleanSource.endsWith(
        '.svg'
      )
    ) {
      return 'image/svg+xml';
    }

    if (
      cleanSource.endsWith(
        '.webp'
      )
    ) {
      return 'image/webp';
    }

    if (
      cleanSource.endsWith(
        '.jpg'
      ) ||
      cleanSource.endsWith(
        '.jpeg'
      )
    ) {
      return 'image/jpeg';
    }

    return 'image/png';
  }

  function loadedLogoDataUrl(
    source
  ) {
    const image =
      Array.from(
        document.querySelectorAll(
          '[data-smoof-logo-editor-frame] img'
        )
      ).find(candidate =>
        candidate.src === source &&
        candidate.complete &&
        candidate.naturalWidth > 0 &&
        candidate.naturalHeight > 0
      );

    if (!image) return '';

    const canvas =
      document.createElement(
        'canvas'
      );

    canvas.width =
      image.naturalWidth;

    canvas.height =
      image.naturalHeight;

    const context =
      canvas.getContext(
        '2d'
      );

    if (!context) return '';

    context.clearRect(
      0,
      0,
      canvas.width,
      canvas.height
    );

    context.drawImage(
      image,
      0,
      0,
      canvas.width,
      canvas.height
    );

    return canvas.toDataURL(
      'image/png',
      1
    );
  }

  async function embeddedLogoSource(
    source
  ) {
    if (
      !source ||
      source.startsWith(
        'data:'
      )
    ) {
      return source || '';
    }

    if (
      logoDataCache.has(
        source
      )
    ) {
      return logoDataCache.get(
        source
      );
    }

    const promise =
      requestResource(
        source,
        'arrayBuffer'
      ).then(resource => {
        const resourceType =
          (
            resource.contentType ||
            ''
          )
            .split(';')[0]
            .trim();

        const contentType =
          resourceType.startsWith(
            'image/'
          )
            ? resourceType
            : inferredImageType(
                source
              );

        return (
          `data:${contentType};base64,` +
          arrayBufferToBase64(
            resource.body
          )
        );
      }).catch(() => {
        const dataUrl =
          loadedLogoDataUrl(
            source
          );

        if (!dataUrl) {
          throw new Error(
            'Uploaded logo could not be embedded'
          );
        }

        return dataUrl;
      });

    logoDataCache.set(
      source,
      promise
    );

    return promise;
  }

  async function proofReadyModel(
    model
  ) {
    const embed = async logo => {
      if (!logo?.visible || !logo?.hasLogo || !logo?.src) return logo;
      return { ...logo, src: await embeddedLogoSource(logo.src) };
    };
    const [logo, logoCopy, logoDuplicate] = await Promise.all([
      embed(model.logo),
      embed(model.logoCopy),
      embed(model.logoDuplicate)
    ]);
    return { ...model, logo, logoCopy, logoDuplicate };
  }

  function googleFontUrl(
    family,
    weight,
    style
  ) {
    const familyQuery =
      encodeURIComponent(family)
        .replace(/%20/g, '+');

    const italic =
      style === 'italic'
        ? 1
        : 0;

    return (
      'https://fonts.googleapis.com/css2?family=' +
      familyQuery +
      ':ital,wght@' +
      italic +
      ',' +
      (
        Number.parseInt(
          weight,
          10
        ) || 400
      ) +
      '&display=swap'
    );
  }

  async function embeddedFontFace(
    family,
    weight,
    style
  ) {
    const normalizedWeight =
      Number.parseInt(
        weight,
        10
      ) || 400;

    const normalizedStyle =
      style === 'italic'
        ? 'italic'
        : 'normal';

    const key = [
      family,
      normalizedWeight,
      normalizedStyle
    ].join('|');

    if (
      fontFaceCache.has(key)
    ) {
      return fontFaceCache.get(key);
    }

    if (
      window.SmoofCustomFontRegistry
        ?.isCustomFamily?.(family)
    ) {
      const customPromise = Promise.resolve(
        window.SmoofCustomFontRegistry
          .fontFaceCss(family)
      );
      fontFaceCache.set(key, customPromise);
      return customPromise;
    }

    const generic =
      /^(Arial|Helvetica|sans-serif|serif|monospace)$/i
        .test(family);

    if (generic) {
      fontFaceCache.set(
        key,
        Promise.resolve('')
      );

      return '';
    }

    const promise =
      requestResource(
        googleFontUrl(
          family,
          normalizedWeight,
          normalizedStyle
        )
      ).then(async response => {
        const css =
          response.body;

        const matches =
          Array.from(
            css.matchAll(
              /url\(([^)]+)\)\s*format\(['"]?([^'")]+)['"]?\)/g
            )
          );

        const match =
          matches.find(candidate =>
            /woff2/i.test(
              candidate[2]
            )
          ) ||
          matches[0];

        if (!match) return '';

        const fontUrl =
          match[1]
            .trim()
            .replace(
              /^["']|["']$/g,
              ''
            );

        const fontResponse =
          await requestResource(
            fontUrl,
            'arrayBuffer'
          );

        const contentType =
          fontResponse.contentType ||
          'font/woff2';

        const base64 =
          arrayBufferToBase64(
            fontResponse.body
          );

        const safeFamily =
          family.replace(
            /["\\]/g,
            ''
          );

        return [
          '@font-face {',
          `font-family: "${safeFamily}";`,
          `font-style: ${normalizedStyle};`,
          `font-weight: ${normalizedWeight};`,
          'font-display: block;',
          `src: url(data:${contentType};base64,${base64}) format("woff2");`,
          '}'
        ].join('');
      }).catch(() => '');

    fontFaceCache.set(
      key,
      promise
    );

    return promise;
  }

  async function embeddedFontsCss(
    model
  ) {
    const items = [
      ...(model.texts || []),
      model.number
    ].filter(item =>
      item?.visible &&
      item.fontFamily
    ).flatMap(item=>item.runs?.length?window.SmoofRichText.pieces(item):[item]);

    const unique =
      new Map();

    items.forEach(item => {
      const key = [
        item.fontFamily,
        item.fontWeight,
        item.fontStyle
      ].join('|');

      unique.set(key, item);
    });

    const faces =
      await Promise.all(
        Array.from(
          unique.values()
        ).map(item =>
          embeddedFontFace(
            item.fontFamily,
            item.fontWeight,
            item.fontStyle
          )
        )
      );

    return faces
      .filter(Boolean)
      .join('\n');
  }

  function serializeSvg(svg) {
    return (
      '<?xml version="1.0" encoding="UTF-8"?>' +
      new XMLSerializer()
        .serializeToString(svg)
    );
  }

  async function canvasPngBytes(
    canvas
  ) {
    const blob =
      await new Promise(
        (resolve, reject) => {
          canvas.toBlob(
            result => {
              if (result) {
                resolve(result);
              } else {
                reject(
                  new Error(
                    'SVG renderer returned no PNG'
                  )
                );
              }
            },
            'image/png',
            1
          );
        }
      );

    return new Uint8Array(
      await blob.arrayBuffer()
    );
  }

  function canvasFont(
    item
  ) {
    const family =
      String(
        item.fontFamily ||
        'Arial'
      ).replace(
        /["\\]/g,
        ''
      );

    return [
      item.fontStyle ===
      'italic'
        ? 'italic'
        : 'normal',
      Number.parseInt(
        item.fontWeight,
        10
      ) || 400,
      `${item.fontSize}px`,
      `"${family}"`
    ].join(' ');
  }

  async function verifyExtraStyles(model) {
    const items = [...(model.texts || []), model.number].filter(item => item?.visible && item.value).flatMap(item=>item.runs?.length?window.SmoofRichText.pieces(item):[item]);
    await Promise.all(items.map(async item => {
      const weight = Number.parseInt(item.fontWeight, 10);
      if (weight !== 200 && weight !== 800) return;
      const style = (weight === 200 ? 'Extra light' : 'Extra fett') + (item.fontStyle === 'italic' ? ' & Kursiv' : '');
      if (!window.SmoofTextTools?.requireExtraStyle) throw new Error(window.SmoofI18n.legacy('Bitte den Editor neu laden, um die Schriftschnitte zu prüfen.'));
      await window.SmoofTextTools.requireExtraStyle(fontFamilyName(item.fontFamily), style);
    }));
  }

  async function ensureCanvasFonts(
    model
  ) {
    if (!document.fonts) return;
    await Promise.all((model.texts||[]).filter(item=>item.visible&&item.runs?.length).map(item=>window.SmoofRichText.ensure(item)));
    for(const item of model.texts||[]){if((!item.runs?.length&&!['left','right','justify'].includes(item.textAlign))||!item.pill?.visible||!item.richBox)continue;
      const lines=window.SmoofRichText.layout(item),width=Math.max(...lines.map(l=>l.width),0)+item.richBox.padX,height=lines.length*(Number(item.lineHeight)||Number(item.fontSize)*1.08)+item.richBox.padY;
      Object.assign(item.pill,{x:item.x-width/2,y:item.y-height/2,width,height});
    }

    const items = [
      ...(model.texts || []),
      model.number
    ].filter(item =>
      item?.visible &&
      item.value
    ).flatMap(item=>item.runs?.length?window.SmoofRichText.pieces(item):[item]);

    await Promise.all(
      items.map(async item => {
        if (
          window.SmoofCustomFontRegistry
            ?.isCustomFamily?.(item.fontFamily)
        ) {
          await window.SmoofCustomFontRegistry
            .ensureLoaded(item.fontFamily);
        }
        return document.fonts
          .load(
            canvasFont(item),
            item.value
          )
          .catch(() => []);
      })
    );
  }

  function drawCanvasText(
    context,
    item,
    opacity = 1
  ) {
    if (
      !item?.visible ||
      !item.value
    ) {
      return;
    }

    if(item.curved){window.SmoofCurvedText.draw(context,item,opacity);return;}
    context.save();
    if (Number(item.rotation)) {
      context.translate(item.x, item.y);
      context.rotate(Number(item.rotation) * Math.PI / 180);
      context.translate(-item.x, -item.y);
    }


    context.font =
      canvasFont(item);

    context.globalAlpha =
      (item.opacity ?? 1) * opacity;

    /*
     * Proof- und Produktions-PDF zeichnen editierbare Texte absichtlich
     * separat auf den Canvas. Der Pillenrahmen gehoert semantisch zum Text
     * und muss deshalb in demselben Pass vor der Schrift gezeichnet werden.
     */
    const pill = item.pill;

    if (
      pill?.visible &&
      Number(pill.width) > 0 &&
      Number(pill.height) > 0
    ) {
      const pillX = Number(pill.x) || 0;
      const pillY = Number(pill.y) || 0;
      const pillWidth = Number(pill.width) || 0;
      const pillHeight = Number(pill.height) || 0;
      const pillRadius = Math.min(
        pillWidth / 2,
        pillHeight / 2
      );

      canvasRoundedRectPath(
        context,
        pillX,
        pillY,
        pillWidth,
        pillHeight,
        pillRadius
      );

      if (
        pill.fill &&
        pill.fill !== 'none' &&
        pill.fill !== 'transparent'
      ) {
        context.fillStyle = pill.fill;
        context.fill();
      }

      const pillStrokeWidth =
        Math.max(
          0,
          Number(pill.strokeWidth) || 0
        );

      if (
        pillStrokeWidth > 0 &&
        pill.stroke &&
        pill.stroke !== 'none' &&
        pill.stroke !== 'transparent'
      ) {
        context.strokeStyle = pill.stroke;
        context.lineWidth = pillStrokeWidth;
        context.stroke();
      }
    }

    if((item.runs?.length || ['left','right','justify'].includes(item.textAlign)) && window.SmoofRichText) {
      context.textAlign='center';context.textBaseline='middle';context.direction='ltr';context.fontKerning='normal';
      for(const line of window.SmoofRichText.layout(item))for(const part of line.parts){
        context.font=canvasFont(part);context.letterSpacing=`${Number(part.letterSpacing)||0}px`;
        context.fillStyle=part.color||'#000000';context.fillText(part.value,part.x,part.y);
      }
      context.restore();return;
    }
    /* Der Pillenpass darf die Textfarbe nicht auf seine Flaeche umstellen. */
    context.fillStyle =
      item.color ||
      '#000000';

    context.textBaseline =
      'middle';

    context.direction =
      'ltr';

    if (
      'fontKerning' in context
    ) {
      context.fontKerning =
        'normal';
    }

    if (
      'textRendering' in context
    ) {
      context.textRendering =
        'geometricPrecision';
    }

    const spacing =
      Number(
        item.letterSpacing
      ) || 0;

    const lines = String(item.value).replace(/\r\n?/g, '\n').split('\n');
    const lineHeight = Number(item.lineHeight) || Number(item.fontSize) * 1.08;
    const firstY = item.y - ((lines.length - 1) * lineHeight) / 2;

    if (!spacing) {
      context.textAlign =
        'center';

      lines.forEach((line, index) => {
        context.fillText(line, item.x, firstY + index * lineHeight);
      });

      context.restore();
      return;
    }

    context.textAlign =
      'left';

    lines.forEach((line, lineIndex) => {
      const characters = Array.from(line);
      const widths = characters.map(character => context.measureText(character).width);
      const totalWidth = widths.reduce((sum, width) => sum + width, 0) +
        spacing * Math.max(0, characters.length - 1);
      let cursor = item.x - totalWidth / 2;

      characters.forEach((character, index) => {
        context.fillText(
          character,
          cursor,
          firstY + lineIndex * lineHeight
        );

        cursor +=
          widths[index] +
          spacing;
      });
    });

    context.restore();
  }

  async function proofLogoImage(
    logo,
    monochrome = false
  ) {
    if (
      !logo?.visible ||
      !logo?.hasLogo ||
      !logo?.src
    ) {
      return null;
    }

    const loadedImage =
      Array.from(
        document.querySelectorAll(
          '[data-smoof-logo-editor-frame] img'
        )
      ).find(candidate =>
        candidate.src ===
          logo.src &&
        candidate.complete &&
        candidate.naturalWidth > 0 &&
        candidate.naturalHeight > 0
      );

    let image = loadedImage;

    if (!image) {
      image = new Image();
      image.decoding = 'sync';

      await new Promise(
        (resolve, reject) => {
          image.onload = resolve;

          image.onerror = () =>
            reject(
              new Error(
                'Uploaded logo could not be decoded'
              )
            );

          image.src =
            logo.src;
        }
      );
    }

    if (!logo.inverted && !monochrome) return image;

    const canvas = document.createElement('canvas');
    canvas.width = image.naturalWidth;
    canvas.height = image.naturalHeight;
    const context = canvas.getContext('2d', { willReadFrequently: true });
    if (!context) return image;

    try {
      context.drawImage(image, 0, 0);
      const pixels = context.getImageData(0, 0, canvas.width, canvas.height);
      for (let index = 0; index < pixels.data.length; index += 4) {
        let red = pixels.data[index];
        let green = pixels.data[index + 1];
        let blue = pixels.data[index + 2];

        if (logo.inverted) {
          red = 255 - red;
          green = 255 - green;
          blue = 255 - blue;
        }

        if (monochrome) {
          const gray = Math.round(
            red * 0.2126 +
            green * 0.7152 +
            blue * 0.0722
          );
          red = gray;
          green = gray;
          blue = gray;
        }

        pixels.data[index] = red;
        pixels.data[index + 1] = green;
        pixels.data[index + 2] = blue;
      }
      context.putImageData(pixels, 0, 0);
      return canvas;
    } catch (error) {
      /* Bei geschützten Fremdquellen übernimmt drawCanvasLogo den Browserfilter. */
      return image;
    }
  }

  async function proofBackgroundImage(
    backgroundImage
  ) {
    const source =
      backgroundImage?.dataUrl || '';

    if (!source) return null;

    const image = new Image();
    image.decoding = 'sync';

    await new Promise(
      (resolve, reject) => {
        image.onload = resolve;
        image.onerror = () =>
          reject(
            new Error(
              'Uploaded background image could not be decoded'
            )
          );
        image.src = source;
      }
    );

    return image;
  }

  function decodedProofImage(
    source,
    errorMessage
  ) {
    const image = new Image();
    image.decoding = 'sync';

    return new Promise(
      (resolve, reject) => {
        image.onload = () =>
          resolve(image);
        image.onerror = () =>
          reject(
            new Error(
              errorMessage
            )
          );
        image.src = source;
      }
    );
  }

  function stainlessTextureImage() {
    if (!STAINLESS_TEXTURE_URL) {
      return Promise.resolve(null);
    }

    if (!stainlessTextureImagePromise) {
      stainlessTextureImagePromise =
        decodedProofImage(
          STAINLESS_TEXTURE_URL,
          'Stainless-steel texture could not be decoded'
        ).catch(error => {
          stainlessTextureImagePromise = null;
          throw error;
        });
    }

    return stainlessTextureImagePromise;
  }

  function isStainlessModel(model) {
    /*
     * Die Proof-Textur beschreibt die bedruckte Designfläche, nicht die
     * physische BASE. RML führt aus Varianten-/Lieferantengründen ebenfalls
     * materialCode="stainless-steel", bedruckt wird dort jedoch die darüber
     * liegende Epoxy-GL-Fläche. Der vom Produktprofil gesetzte semantische
     * Designflächenwert grenzt Edelstahl deshalb gezielt auf DOT ME ein.
     */
    return document.documentElement.dataset
      .smoofPrintSurfaceMaterial ===
      'stainless-steel';
  }

  function isLaserModel(model) {
    return (
      model?.productVariant?.printProcess ===
        'laser' ||
      document.documentElement.dataset
        .smoofPrintProcess ===
        'laser'
    );
  }

  function drawCanvasMaterialTexture(
    context,
    image,
    box
  ) {
    if (!image) return;

    const sourceWidth =
      image.naturalWidth ||
      image.width ||
      1;
    const sourceHeight =
      image.naturalHeight ||
      image.height ||
      1;
    const sourceSize =
      Math.min(
        sourceWidth,
        sourceHeight
      );
    const sourceX =
      (sourceWidth - sourceSize) / 2;
    const sourceY =
      (sourceHeight - sourceSize) / 2;

    context.save();
    context.beginPath();
    context.arc(
      box.x + box.width / 2,
      box.y + box.height / 2,
      Math.min(
        box.width,
        box.height
      ) / 2,
      0,
      Math.PI * 2
    );
    context.clip();
    context.drawImage(
      image,
      sourceX,
      sourceY,
      sourceSize,
      sourceSize,
      box.x,
      box.y,
      box.width,
      box.height
    );
    // Match the live stainless surface; artwork and production stay untouched.
    context.fillStyle = "rgba(255,255,255,.55)";
    context.fillRect(box.x, box.y, box.width, box.height);
    context.restore();
  }

  function laserBlackColor(value) {
    const color = String(value || '').trim();
    if (!color || /^(none|transparent)$/i.test(color)) return value;
    return '#000000';
  }

  function monochromeModel(model) {
    const copy = typeof structuredClone === 'function'
      ? structuredClone(model)
      : JSON.parse(JSON.stringify(model));

    const visit = value => {
      if (!value || typeof value !== 'object') return;
      Object.entries(value).forEach(([key, entry]) => {
        if (key === 'originalColours') { value[key] = false;
        } else if (typeof entry === 'string' && /(color|fill|stroke)$/i.test(key)) {
          value[key] = laserBlackColor(entry);
        } else if (typeof entry === 'number' && /opacity$/i.test(key)) {
          value[key] = 1;
        } else if (entry && typeof entry === 'object') {
          visit(entry);
        }
      });
    };

    visit(copy);
    if (copy.payments) copy.payments.originalColours = false;
    Object.values(copy.socialPlatforms?.objects || {}).forEach(object => { object.originalColours = false; });
    return copy;
  }

  async function proofEditorQrImage() {
    if (!editorQrImagePromise) {
      editorQrImagePromise =
        editorQrDataUrl()
          .then(source =>
            decodedProofImage(
              source,
              'Editor QR could not be decoded'
            )
          )
          .catch(error => {
            editorQrImagePromise = null;
            throw error;
          });
    }

    return editorQrImagePromise;
  }

  function canvasBackgroundFill(
    context,
    model,
    box
  ) {
    const gradient =
      model.backgroundGradient;

    if (!gradient?.enabled) {
      return model.backgroundColor ||
        '#000000';
    }

    const angle =
      Number(gradient.angle) || 0;
    const radians =
      angle * Math.PI / 180;
    const halfDiagonal =
      Math.hypot(box.width, box.height) / 2;
    const dx =
      Math.sin(radians) * halfDiagonal;
    const dy =
      -Math.cos(radians) * halfDiagonal;
    const centerX =
      box.x + box.width / 2;
    const centerY =
      box.y + box.height / 2;
    const canvasGradient =
      context.createLinearGradient(
        centerX - dx,
        centerY - dy,
        centerX + dx,
        centerY + dy
      );

    canvasGradient.addColorStop(
      0,
      gradient.color1 ||
        model.backgroundColor ||
        '#000000'
    );
    canvasGradient.addColorStop(
      1,
      gradient.color2 ||
        '#ffffff'
    );

    return canvasGradient;
  }

  function drawCanvasBackground(
    context,
    model,
    image,
    box,
    circular = false,
    imageBox = box
  ) {
    context.save();

    if (circular) {
      context.beginPath();
      context.arc(
        box.x + box.width / 2,
        box.y + box.height / 2,
        Math.min(box.width, box.height) / 2,
        0,
        Math.PI * 2
      );
      context.clip();
    }

    context.fillStyle =
      canvasBackgroundFill(
        context,
        model,
        box
      );
    const backgroundOpacity =
      Math.max(
        0,
        Math.min(1, Number(model.backgroundOpacity) || 1)
      );
    if (backgroundOpacity < 1) context.save();
    context.globalAlpha = backgroundOpacity;
    context.fillRect(
      box.x,
      box.y,
      box.width,
      box.height
    );
    if (backgroundOpacity < 1) context.restore();

    if (
      image &&
      image.naturalWidth > 0 &&
      image.naturalHeight > 0
    ) {
      const baseScale = Math.max(
        imageBox.width / image.naturalWidth,
        imageBox.height / image.naturalHeight
      );
      const zoom = Math.max(0.05, Math.min(3, Number(model.backgroundImage?.scale) || 1));
      const positionX = Math.max(0, Math.min(1, Number.isFinite(Number(model.backgroundImage?.positionX)) ? Number(model.backgroundImage.positionX) : 0.5));
      const positionY = Math.max(0, Math.min(1, Number.isFinite(Number(model.backgroundImage?.positionY)) ? Number(model.backgroundImage.positionY) : 0.5));
      if (zoom >= 1) {
        const sourceWidth =
          imageBox.width / baseScale / zoom;
        const sourceHeight =
          imageBox.height / baseScale / zoom;
        const sourceX =
          (image.naturalWidth - sourceWidth) * positionX;
        const sourceY =
          (image.naturalHeight - sourceHeight) * positionY;

        context.drawImage(
          image,
          sourceX,
          sourceY,
          sourceWidth,
          sourceHeight,
          imageBox.x,
          imageBox.y,
          imageBox.width,
          imageBox.height
        );
      } else {
        const renderedWidth =
          image.naturalWidth * baseScale * zoom;
        const renderedHeight =
          image.naturalHeight * baseScale * zoom;
        const renderedX =
          imageBox.x +
          (imageBox.width - renderedWidth) * positionX;
        const renderedY =
          imageBox.y +
          (imageBox.height - renderedHeight) * positionY;

        context.drawImage(
          image,
          renderedX,
          renderedY,
          renderedWidth,
          renderedHeight
        );
      }
    }

    const overlay = model.backgroundGradient;
    const overlayOpacity = Math.max(0, Math.min(1, Number(overlay?.overlayOpacity) || 0));
    if (overlay?.overlayEnabled && overlayOpacity > 0) {
      context.save();
      context.globalAlpha = overlayOpacity;
      context.fillStyle = overlay.overlayColor || '#000000';
      context.fillRect(box.x, box.y, box.width, box.height);
      context.restore();
    }

    context.restore();
  }

  function drawCanvasLogo(
    context,
    logo,
    image
  ) {
    const sourceWidth = image?.naturalWidth || image?.width || 0;
    const sourceHeight = image?.naturalHeight || image?.height || 0;
    if (
      !logo?.visible ||
      !logo?.hasLogo ||
      !image ||
      sourceWidth <= 0 ||
      sourceHeight <= 0
    ) {
      return;
    }

    const imageRatio =
      sourceWidth /
      sourceHeight;

    const frameRatio =
      logo.width /
      logo.height;

    let width;
    let height;

    if (
      imageRatio >
      frameRatio
    ) {
      width = logo.width;
      height =
        width /
        imageRatio;
    } else {
      height = logo.height;
      width =
        height *
        imageRatio;
    }

    const x =
      logo.x +
      (
        logo.width -
        width
      ) / 2;

    const y =
      logo.y +
      (
        logo.height -
        height
      ) / 2;

    const centerX =
      logo.x +
      logo.width / 2;

    const centerY =
      logo.y +
      logo.height / 2;

    context.save();

    context.globalAlpha = logo.opacity ?? 1;

    context.translate(
      centerX,
      centerY
    );

    context.rotate(
      (
        Number(
          logo.rotation
        ) || 0
      ) *
      Math.PI /
      180
    );

    const backgroundBox = logoBackgroundBox(logo);
    if (backgroundBox) {
      context.fillStyle = backgroundBox.color;
      context.beginPath();
      if (backgroundBox.shape === 'circle') {
        context.arc(
          backgroundBox.x + backgroundBox.width / 2 - centerX,
          backgroundBox.y + backgroundBox.height / 2 - centerY,
          backgroundBox.width / 2,
          0,
          Math.PI * 2
        );
      } else if (backgroundBox.shape === 'rounded') {
        const roundedX = backgroundBox.x - centerX;
        const roundedY = backgroundBox.y - centerY;
        const roundedWidth = backgroundBox.width;
        const roundedHeight = backgroundBox.height;
        const roundedRadius = Math.min(roundedWidth, roundedHeight) * 0.25;
        if (typeof context.roundRect === 'function') {
          context.roundRect(roundedX, roundedY, roundedWidth, roundedHeight, roundedRadius);
        } else {
          context.moveTo(roundedX + roundedRadius, roundedY);
          context.lineTo(roundedX + roundedWidth - roundedRadius, roundedY);
          context.quadraticCurveTo(roundedX + roundedWidth, roundedY, roundedX + roundedWidth, roundedY + roundedRadius);
          context.lineTo(roundedX + roundedWidth, roundedY + roundedHeight - roundedRadius);
          context.quadraticCurveTo(roundedX + roundedWidth, roundedY + roundedHeight, roundedX + roundedWidth - roundedRadius, roundedY + roundedHeight);
          context.lineTo(roundedX + roundedRadius, roundedY + roundedHeight);
          context.quadraticCurveTo(roundedX, roundedY + roundedHeight, roundedX, roundedY + roundedHeight - roundedRadius);
          context.lineTo(roundedX, roundedY + roundedRadius);
          context.quadraticCurveTo(roundedX, roundedY, roundedX + roundedRadius, roundedY);
          context.closePath();
        }
      } else {
        context.rect(
          backgroundBox.x - centerX,
          backgroundBox.y - centerY,
          backgroundBox.width,
          backgroundBox.height
        );
      }
      context.fill();
    }

    if (logo.inverted && image instanceof HTMLImageElement) {
      context.filter = 'invert(1)';
    }

    context.drawImage(
      image,
      x - centerX,
      y - centerY,
      width,
      height
    );

    context.restore();
  }

  function drawCanvasBrandDot(
    context,
    brandDot
  ) {
    if (!brandDot?.visible) {
      return;
    }

    context.save();
    context.globalAlpha =
      brandDot.opacity ?? 1;
    context.fillStyle =
      brandDot.color ||
      '#000000';
    context.beginPath();
    context.arc(
      brandDot.x,
      brandDot.y,
      brandDot.radius,
      0,
      Math.PI * 2
    );
    context.fill();
    context.restore();
  }

  function canvasRoundedRectPath(
    context,
    x,
    y,
    width,
    height,
    radius
  ) {
    context.beginPath();
    context.moveTo(
      x + radius,
      y
    );
    context.lineTo(
      x + width - radius,
      y
    );
    context.quadraticCurveTo(
      x + width,
      y,
      x + width,
      y + radius
    );
    context.lineTo(
      x + width,
      y + height - radius
    );
    context.quadraticCurveTo(
      x + width,
      y + height,
      x + width - radius,
      y + height
    );
    context.lineTo(
      x + radius,
      y + height
    );
    context.quadraticCurveTo(
      x,
      y + height,
      x,
      y + height - radius
    );
    context.lineTo(
      x,
      y + radius
    );
    context.quadraticCurveTo(
      x,
      y,
      x + radius,
      y
    );
    context.closePath();
  }

  function drawCanvasProofEditorQr(
    context,
    image,
    model = null
  ) {
    const panel = qrPanel(model);

    context.save();
    canvasRoundedRectPath(
      context,
      panel.x,
      panel.y,
      panel.width,
      panel.height,
      panel.radius
    );
    if (qrBackingVisible(model)) {
      context.fillStyle = qrBackingColor(model);
      context.fill();
    }
    context.clip();

    if (!qrVisible(model) || !image) {
      context.restore();
      return;
    }

    /*
     * Das transparente Easify-Asset ist bereits auf 1600 x 1600 an der
     * Editorposition angelegt. Vollflächiges Zeichnen auf den 1000er-ViewBox
     * übernimmt deshalb Größe und Position exakt und umgeht verschachtelte
     * SVG-Bilder, die in Safari/jsPDF unsichtbar blieben.
     */
    let renderedImage = image;
    const sourceWidth = image.naturalWidth || image.width || 0;
    const sourceHeight = image.naturalHeight || image.height || 0;
    if (sourceWidth > 0 && sourceHeight > 0) {
      const colourCanvas = document.createElement('canvas');
      colourCanvas.width = sourceWidth;
      colourCanvas.height = sourceHeight;
      const colourContext = colourCanvas.getContext('2d');
      if (colourContext) {
        colourContext.drawImage(image, 0, 0, sourceWidth, sourceHeight);
        colourContext.globalCompositeOperation = 'source-in';
        colourContext.fillStyle = qrCodeColor(model);
        colourContext.fillRect(0, 0, sourceWidth, sourceHeight);
        renderedImage = colourCanvas;
      }
    }
    context.drawImage(
      renderedImage,
      panel.x - QR_PANEL.x * panel.scale,
      panel.y - QR_PANEL.y * panel.scale,
      VIEWBOX_SIZE * panel.scale,
      VIEWBOX_SIZE * panel.scale
    );
    context.restore();
  }

  async function renderPng({
    diameter =
      getPrintDiameterMm(),
    model =
      readModel(),
    includeProofTrimGuide = true,
    includeBackground = true
  } = {}) {
    if(window.SmoofCurvedText)model=await window.SmoofCurvedText.prepare(model);
    window.SmoofCurvedText?.assertReady(model);
    await verifyExtraStyles(model);
    await document.fonts?.ready;

    const stainless =
      isStainlessModel(model);

    const laser =
      isLaserModel(model);

    const proofModel =
      await proofReadyModel(
        laser
          ? monochromeModel(model)
          : model
      );

    await ensureCanvasFonts(
      proofModel
    );

    const logoImage =
      await proofLogoImage(
        proofModel.logo,
        laser
      );

    const logoCopyImage =
      await proofLogoImage(
        proofModel.logoCopy,
        laser
      );

    const logoDuplicateImage =
      await proofLogoImage(
        proofModel.logoDuplicate,
        laser
      );

    const backgroundImage =
      laser
        ? null
        : await proofBackgroundImage(
            proofModel.backgroundImage
          );

    const materialTexture =
      stainless && includeBackground
        ? await stainlessTextureImage()
        : null;

    /*
     * Der QR wird getrennt geladen und erst auf den finalen Canvas gezeichnet.
     * Verschachtelte SVG-Images verschwinden insbesondere beim Safari/jsPDF-
     * Rasterisieren sporadisch, obwohl sie im DOM vorhanden sind.
     */
    const editorQrImage =
      await proofEditorQrImage();

    const svg =
      await buildSvg(
        proofModel,
        {
          proof: true,
          includeProofTrimGuide,
          includeBackground:
            false,
          includeEditableText:
            false,
          includeUploadedLogo:
            false,
          includeBrandDot:
            false,
          includeProofEditorQr:
            false,
          includeNfcIcon:
            false
        }
      );

    const source =
      serializeSvg(svg);

    const blob =
      new Blob(
        [source],
        {
          type:
            'image/svg+xml;charset=utf-8'
        }
      );

    const url =
      URL.createObjectURL(blob);

    const image =
      new Image();

    image.decoding = 'sync';

    try {
      await new Promise(
        (resolve, reject) => {
          image.onload = resolve;
          image.onerror =
            () => reject(
              new Error(
                'Generated SVG could not be loaded'
              )
            );

          image.src = url;
        }
      );

      const targetPixels =
        Math.max(
          1200,
          Math.round(
            diameter /
            (
              PRINT_RADIUS *
              2 /
              VIEWBOX_SIZE
            ) /
            25.4 *
            300
          )
        );

      const canvas =
        document.createElement(
          'canvas'
        );

      canvas.width =
        targetPixels;

      canvas.height =
        targetPixels;

      const context =
        canvas.getContext(
          '2d',
          {
            alpha: !includeBackground
          }
        );

      if (!context) {
        throw new Error(
          'Canvas renderer unavailable'
        );
      }

      // Transparent artwork is opt-in for metallic 360 previews only.
      // Existing proof callers retain the opaque white canvas by default.
      if (includeBackground) {
        context.fillStyle = '#ffffff';
        context.fillRect(0, 0, targetPixels, targetPixels);
      }

      const canvasScale =
        targetPixels /
        VIEWBOX_SIZE;

      context.save();
      context.scale(
        canvasScale,
        canvasScale
      );
      const artworkBox = {
        x: 500 - PRINT_RADIUS,
        y: 500 - PRINT_RADIUS,
        width: PRINT_RADIUS * 2,
        height: PRINT_RADIUS * 2
      };

      if (includeBackground && stainless) {
        drawCanvasMaterialTexture(
          context,
          materialTexture,
          artworkBox
        );
      }

      if (includeBackground && !laser) {
        if (stainless) {
          context.globalAlpha = 0.82;
          context.globalCompositeOperation = 'multiply';
        }

        drawCanvasBackground(
          context,
          proofModel,
          backgroundImage,
          artworkBox,
          true,
          {
            x: 0,
            y: 0,
            width: VIEWBOX_SIZE,
            height: VIEWBOX_SIZE
          }
        );
      } else if (includeBackground && !stainless) {
        drawCanvasBackground(
          context,
          proofModel,
          null,
          artworkBox,
          true,
          {
            x: 0,
            y: 0,
            width: VIEWBOX_SIZE,
            height: VIEWBOX_SIZE
          }
        );
      }
      context.restore();

      context.drawImage(
        image,
        0,
        0,
        targetPixels,
        targetPixels
      );

      context.save();

      context.scale(
        canvasScale,
        canvasScale
      );

      drawCanvasLogo(
        context,
        proofModel.logo,
        logoImage
      );

      drawCanvasLogo(
        context,
        proofModel.logoCopy,
        logoCopyImage
      );

      drawCanvasLogo(
        context,
        proofModel.logoDuplicate,
        logoDuplicateImage
      );

      (proofModel.texts || [])
        .forEach(item => {
          drawCanvasText(
            context,
            item
          );
        });

      drawCanvasText(
        context,
        proofModel.number,
        1
      );

      /*
       * Die konfigurierte Hintergrundfläche wird hier bewusst nochmals
       * vollständig gezeichnet:
       * Es entfernt die alte graue QR-Platzhalterfläche aus der gerasterten
       * Vorschau. Darauf folgt der echte Editor-QR. Bei einem NFC-Produkt wird
       * anschließend wird ausschließlich die lokale NFC-Vektorgeometrie
       * ergänzt. Dadurch gibt es weder einen weißen SVG-Hintergrund noch
       * unterschiedliche Browserpfade.
       */
      drawCanvasProofEditorQr(
        context,
        editorQrImage,
        proofModel
      );

      drawCanvasNfc(
        context,
        proofModel
      );

      /*
       * Der Brandingkreis wird ganz zuletzt gezeichnet. Dadurch liegt er
       * auch bei deckenden JPEG-Logos zuverlässig sichtbar oben.
       */
      drawCanvasBrandDot(
        context,
        proofModel.brandDot
      );

      context.restore();

      return canvasPngBytes(
        canvas
      );
    } finally {
      URL.revokeObjectURL(url);
    }
  }

  async function renderProductionPng({
    diameter =
      getPrintDiameterMm(),
    bleedMm = 2.5,
    dpi = 600,
    model =
      readModel()
  } = {}) {
    if(window.SmoofCurvedText)model=await window.SmoofCurvedText.prepare(model);
    window.SmoofCurvedText?.assertReady(model);
    await verifyExtraStyles(model);
    const trimDiameterMm =
      Number(diameter) || 80;

    const safeBleedMm =
      Math.max(
        0,
        Number(bleedMm) || 0
      );

    const safeDpi =
      Math.max(
        300,
        Number(dpi) || 600
      );

    const pageSizeMm =
      trimDiameterMm +
      safeBleedMm * 2;

    const printDiameterUnits =
      PRINT_RADIUS * 2;

    const unitsPerMm =
      printDiameterUnits /
      trimDiameterMm;

    const bleedUnits =
      safeBleedMm *
      unitsPerMm;

    const productionViewBox = {
      x:
        500 -
        PRINT_RADIUS -
        bleedUnits,
      y:
        500 -
        PRINT_RADIUS -
        bleedUnits,
      size:
        printDiameterUnits +
        bleedUnits * 2
    };

    await document.fonts?.ready;

    // Production-only substrate: DOT ME colour print always starts on white.
    // Preserve editor/Proof state and use captured variant metadata for exports.
    const variant = model?.productVariant || {};
    const whiteSubstrate =
      (variant.profileId || window.SmoofProductProfiles?.current?.id) === 'dot-me-stainless-single' &&
      (variant.printProcess || document.documentElement.dataset.smoofPrintProcess) === 'color-print';
    const productionSource = whiteSubstrate ? {
      ...model,
      backgroundColor: '#FFFFFF',
      backgroundOpacity: 1,
      backgroundGradient: null,
      backgroundImage: null
    } : model;
    const productionModel =
      await proofReadyModel(
        productionSource
      );

    await ensureCanvasFonts(
      productionModel
    );

    const logoImage =
      await proofLogoImage(
        productionModel.logo
      );

    const logoCopyImage =
      await proofLogoImage(
        productionModel.logoCopy
      );

    const logoDuplicateImage =
      await proofLogoImage(
        productionModel.logoDuplicate
      );

    const backgroundImage =
      await proofBackgroundImage(
        productionModel.backgroundImage
      );

    const svg =
      await buildSvg(
        productionModel,
        {
          productionViewBox,
          includeBackground:
            false,
          includeEditableText:
            false,
          includeUploadedLogo:
            false,
          includeLogoPlaceholder:
            false,
          includeBrandDot:
            false
        }
      );

    const source =
      serializeSvg(svg);

    const blob =
      new Blob(
        [source],
        {
          type:
            'image/svg+xml;charset=utf-8'
        }
      );

    const url =
      URL.createObjectURL(blob);

    const image =
      new Image();

    image.decoding = 'sync';

    try {
      await new Promise(
        (resolve, reject) => {
          image.onload = resolve;

          image.onerror = () =>
            reject(
              new Error(
                'Production SVG could not be loaded'
              )
            );

          image.src = url;
        }
      );

      const targetPixels =
        Math.max(
          1,
          Math.round(
            pageSizeMm /
            25.4 *
            safeDpi
          )
        );

      const canvas =
        document.createElement(
          'canvas'
        );

      canvas.width =
        targetPixels;

      canvas.height =
        targetPixels;

      const context =
        canvas.getContext(
          '2d',
          {
            alpha: false
          }
        );

      if (!context) {
        throw new Error(
          'Production canvas unavailable'
        );
      }

      context.fillStyle = '#ffffff';

      context.fillRect(
        0,
        0,
        targetPixels,
        targetPixels
      );

      const canvasScale =
        targetPixels /
        productionViewBox.size;

      context.save();

      context.scale(
        canvasScale,
        canvasScale
      );

      context.translate(
        -productionViewBox.x,
        -productionViewBox.y
      );

      drawCanvasBackground(
        context,
        productionModel,
        backgroundImage,
        {
          x: productionViewBox.x,
          y: productionViewBox.y,
          width: productionViewBox.size,
          height: productionViewBox.size
        },
        false,
        {
          x: 0,
          y: 0,
          width: VIEWBOX_SIZE,
          height: VIEWBOX_SIZE
        }
      );

      context.restore();

      context.drawImage(
        image,
        0,
        0,
        targetPixels,
        targetPixels
      );

      context.save();

      context.scale(
        canvasScale,
        canvasScale
      );

      context.translate(
        -productionViewBox.x,
        -productionViewBox.y
      );

      drawCanvasLogo(
        context,
        productionModel.logo,
        logoImage
      );

      drawCanvasLogo(
        context,
        productionModel.logoCopy,
        logoCopyImage
      );

      drawCanvasLogo(
        context,
        productionModel.logoDuplicate,
        logoDuplicateImage
      );

      (productionModel.texts || [])
        .forEach(item => {
          drawCanvasText(
            context,
            item
          );
        });

      drawCanvasText(
        context,
        productionModel.number,
        1
      );

      drawCanvasBrandDot(
        context,
        productionModel.brandDot
      );

      context.restore();

      return {
        bytes:
          await canvasPngBytes(
            canvas
          ),
        trimDiameterMm,
        bleedMm:
          safeBleedMm,
        pageSizeMm,
        dpi:
          safeDpi,
        pixelSize:
          targetPixels,
        qr: {
          visible: qrVisible(productionModel),
          codeColor: qrCodeColor(productionModel),
          backingVisible: qrBackingVisible(productionModel),
          backingColor: qrBackingColor(productionModel)
        }
      };
    } finally {
      URL.revokeObjectURL(url);
    }
  }

  function fontFamilyName(value) {
    const family = String(value || 'Roboto')
      .split(',')[0]
      .replace(/["']/g, '')
      .trim();

    return /^(Arial|Helvetica|sans-serif)$/i.test(family)
      ? 'Roboto'
      : family || 'Roboto';
  }

  function loadFontKit() {
    if (!fontKitPromise) {
      fontKitPromise = import(FONTKIT_URL)
        .then(module => {
          const fontKit =
            module.default?.create
              ? module.default
              : module;

          if (typeof fontKit.create !== 'function') {
            throw new Error('Font vector library unavailable');
          }

          return fontKit;
        })
        .catch(error => {
          fontKitPromise = null;
          throw error;
        });
    }

    return fontKitPromise;
  }

  function googleFontFileUrl(css) {
    const blocks =
      String(css || '').match(/@font-face\s*\{[\s\S]*?\}/g) || [];

    const preferred =
      blocks.find(block =>
        /unicode-range\s*:\s*[^;]*U\+0000-00FF/i.test(block)
      ) ||
      blocks[blocks.length - 1] ||
      '';

    const match = preferred.match(
      /src\s*:\s*url\(([^)]+)\)/i
    );

    return match?.[1]
      ?.trim()
      .replace(/^["']|["']$/g, '') || '';
  }

  async function laserFont(item) {
    const family =
      fontFamilyName(item?.fontFamily);
    const weight =
      Number.parseInt(item?.fontWeight, 10) || 400;
    const style =
      item?.fontStyle === 'italic'
        ? 'italic'
        : 'normal';
    const key = `${family}|${weight}|${style}`;

    if (!laserFontCache.has(key)) {
      laserFontCache.set(
        key,
        (async () => {
          const customBytes =
            window.SmoofCustomFontRegistry
              ?.bytesFor?.(family);

          if (customBytes) {
            const fontKit = await loadFontKit();
            return fontKit.create(
              new Uint8Array(customBytes)
            );
          }

          const [fontKit, cssResponse] = await Promise.all([
            loadFontKit(),
            requestResource(
              googleFontUrl(family, weight, style)
            )
          ]);
          const fontUrl =
            googleFontFileUrl(cssResponse.body);

          if (!fontUrl) {
            throw new Error(
              `Schrift „${family}“ kann nicht in Laserpfade umgewandelt werden.`
            );
          }

          const fontResponse =
            await requestResource(
              fontUrl,
              'arrayBuffer'
            );

          return fontKit.create(
            new Uint8Array(fontResponse.body)
          );
        })().catch(error => {
          laserFontCache.delete(key);
          throw error;
        })
      );
    }

    return laserFontCache.get(key);
  }

  function fontPathData(path) {
    const value = String(path?.toSVG?.() || '');
    if (!value.startsWith('<')) return value;

    return new DOMParser()
      .parseFromString(value, 'image/svg+xml')
      .documentElement
      .getAttribute('d') || '';
  }

  function paperPathScope() {
    if (laserPathScope) return laserPathScope;

    const paper = window.paper;
    if (!paper?.PaperScope) {
      throw new Error(
        window.SmoofI18n.legacy('Die Laser-Pfadbereinigung ist nicht geladen. Bitte die Seite neu laden und den Export erneut starten.')
      );
    }

    laserPathScope = new paper.PaperScope();
    laserPathScope.setup(new laserPathScope.Size(1, 1));
    return laserPathScope;
  }

  /*
   * TrueType-Schriften duerfen intern aus ueberlappenden Konturen bestehen.
   * Das ist fuer Bildschirm und Druck unsichtbar, erzeugt beim Laser aber
   * doppelte Fahrwege. Gleichgerichtete Aussenkonturen werden nacheinander
   * vereinigt; entgegengesetzt gerichtete Innenkonturen werden anschliessend
   * abgezogen. So bleiben Punzen erhalten und zusammengesetzte Glyphen wie M
   * ergeben auch dann eine Flaeche, wenn eine Selbstvereinigung leer waere.
   */
  function unionFontPathData(pathData) {
    if (!pathData) return '';

    const scope = paperPathScope();
    scope.activate();
    scope.project.clear();

    let source = null;
    let contours = [];
    let united = null;

    try {
      source = new scope.CompoundPath(pathData);
      source.fillRule = 'nonzero';

      contours = source.children.map(child =>
        child.clone({ insert: false })
      );

      const largest = contours.reduce(
        (current, contour) => (
          !current || Math.abs(contour.area) > Math.abs(current.area)
            ? contour
            : current
        ),
        null
      );

      if (!largest) {
        throw new Error('Die Glyphe enthaelt keine geschlossene Kontur.');
      }

      const outerClockwise = largest.clockwise;
      const outerContours = contours.filter(
        contour => contour.clockwise === outerClockwise
      );
      const innerContours = contours.filter(
        contour => contour.clockwise !== outerClockwise
      );

      united = outerContours.shift() || null;

      for (const outer of outerContours) {
        const next = united.unite(outer, {
          insert: false,
          trace: true
        });
        united.remove();
        outer.remove();
        united = next;
      }

      for (const inner of innerContours) {
        const next = united.subtract(inner, {
          insert: false,
          trace: true
        });
        united.remove();
        inner.remove();
        united = next;
      }

      united.reorient?.(true);

      const cleaned = String(united.pathData || '').trim();
      if (!cleaned) {
        throw new Error('Leerer Pfad nach der Flaechenvereinigung.');
      }
      return cleaned;
    } catch (error) {
      throw new Error(
        `Eine Schriftkontur konnte nicht laserfertig vereinigt werden: ${error?.message || error}`
      );
    } finally {
      united?.remove?.();
      contours.forEach(contour => contour.remove?.());
      source?.remove?.();
      scope.project.clear();
    }
  }

  async function outlinedTextGroup(item) {
    if (!item?.visible || !item.value) return null;

    if(item.curved){const holder=createSvgElement('g');window.SmoofCurvedText.append(holder,item,true);return holder;}
    if((item.runs?.length || ['left','right','justify'].includes(item.textAlign)) && window.SmoofRichText) {
      const group=createSvgElement('g',{transform:`rotate(${Number(item.rotation)||0} ${item.x} ${item.y})`,'data-smoof-laser-rich-text':String(item.id||item.index)});
      if(item.pill?.visible){const p=item.pill;group.appendChild(createSvgElement('rect',{x:p.x,y:p.y,width:p.width,height:p.height,rx:p.height/2,fill:p.fill||'none',stroke:p.stroke||'none','stroke-width':p.strokeWidth||0}));}
      for(const line of window.SmoofRichText.layout(item))for(const part of line.parts){const child=await outlinedTextGroup({...part,pill:null,rotation:0});if(child)group.appendChild(child);}
      return group;
    }
    const font = await laserFont(item);
    const fontSize = Math.max(1, Number(item.fontSize) || 16);
    const unitsPerEm = Number(font.unitsPerEm) || 1000;
    const scale = fontSize / unitsPerEm;
    const spacing = Number(item.letterSpacing) || 0;
    const lineHeight = Number(item.lineHeight) || fontSize * 1.08;
    const lines = String(item.value).replace(/\r\n?/g, '\n').split('\n');
    const firstY = Number(item.y) - ((lines.length - 1) * lineHeight) / 2;
    const group = createSvgElement('g', {
      fill: item.color || '#000000',
      opacity: item.opacity ?? 1,
      transform: `rotate(${Number(item.rotation) || 0} ${item.x} ${item.y})`,
      'data-smoof-laser-text-outline': String(item.id || item.index || 'text')
    });

    if (item.pill?.visible) {
      const pill = item.pill;
      group.appendChild(createSvgElement('rect', {
        x: pill.x,
        y: pill.y,
        width: pill.width,
        height: pill.height,
        rx: Number(pill.height) / 2,
        ry: Number(pill.height) / 2,
        fill: pill.fill || 'none',
        stroke: pill.stroke || 'none',
        'stroke-width': Number(pill.strokeWidth) || 0
      }));
    }

    lines.forEach((line, lineIndex) => {
      const run = font.layout(line || ' ');
      const positions = run.positions || [];
      const advances = run.glyphs.map((glyph, index) =>
        Number(positions[index]?.xAdvance ?? glyph.advanceWidth ?? 0)
      );
      const totalWidth =
        advances.reduce((sum, advance) => sum + advance * scale, 0) +
        spacing * Math.max(0, run.glyphs.length - 1);
      let cursor = Number(item.x) - totalWidth / 2;
      const lineCenterY = firstY + lineIndex * lineHeight;
      const baselineY = lineCenterY +
        ((Number(font.ascent) || unitsPerEm * 0.8) +
          (Number(font.descent) || -unitsPerEm * 0.2)) * scale / 2;

      run.glyphs.forEach((glyph, glyphIndex) => {
        const position = positions[glyphIndex] || {};
        const pathData = unionFontPathData(
          fontPathData(glyph.path)
        );

        if (pathData) {
          group.appendChild(createSvgElement('path', {
            d: pathData,
            transform: [
              `translate(${cursor + (Number(position.xOffset) || 0) * scale} ${baselineY - (Number(position.yOffset) || 0) * scale})`,
              `scale(${scale} ${-scale})`
            ].join(' '),
            'fill-rule': 'nonzero',
            'data-smoof-laser-path-unioned': 'true'
          }));
        }

        cursor += advances[glyphIndex] * scale + spacing;
      });
    });

    return group;
  }

  async function replaceSvgTextWithOutlines(svg) {
    const nodes = Array.from(svg.querySelectorAll('text'));

    for (const node of nodes) {
      const computed = {
        id: node.getAttribute('data-smoof-text-rendered') || 'vector-label',
        visible: true,
        value: node.textContent || '',
        x: Number(node.getAttribute('x')) || 0,
        y: Number(node.getAttribute('y')) || 0,
        color: node.getAttribute('fill') || '#000000',
        fontFamily: node.getAttribute('font-family') || 'Roboto',
        fontSize: Number(node.getAttribute('font-size')) || 16,
        fontWeight: node.getAttribute('font-weight') || '400',
        fontStyle: node.getAttribute('font-style') || 'normal',
        letterSpacing: Number(node.getAttribute('letter-spacing')) || 0,
        opacity: Number(node.getAttribute('opacity') || 1)
      };
      const outline = await outlinedTextGroup(computed);
      if (outline) node.replaceWith(outline);
      else node.remove();
    }
  }

  function svgSourceText(source) {
    if (!String(source).startsWith('data:')) return null;
    const [header, payload = ''] = String(source).split(',', 2);
    if (!/;base64/i.test(header)) {
      return decodeURIComponent(payload);
    }

    const binary = atob(payload);
    const bytes = Uint8Array.from(
      binary,
      character => character.charCodeAt(0)
    );
    return new TextDecoder().decode(bytes);
  }

  async function vectorLogoDocument(logo) {
    const inline = svgSourceText(logo.src);
    const source = inline ?? (await requestResource(logo.src)).body;

    if (!/<svg[\s>]/i.test(source)) {
      throw new Error(
        window.SmoofI18n.legacy('Für die Lasergravur dürfen Logos ausschließlich als echte SVG-Vektordateien hochgeladen werden.')
      );
    }

    if (/url\(\s*["']?(?!#)/i.test(source)) {
      throw new Error(
        window.SmoofI18n.legacy('Das SVG-Logo enthält eine externe oder eingebettete Rasterquelle.')
      );
    }

    const parsed = new DOMParser().parseFromString(source, 'image/svg+xml');
    const root = parsed.documentElement;
    const invalid = root.querySelector(
      'image, text, tspan, foreignObject, script, video, canvas, iframe'
    );

    if (root.tagName.toLowerCase() !== 'svg' || invalid) {
      throw new Error(
        window.SmoofI18n.legacy('Das SVG-Logo muss vollständig aus Vektorpfaden und Vektorformen bestehen.')
      );
    }

    root.querySelectorAll('*').forEach(element => {
      Array.from(element.attributes).forEach(attribute => {
        if (/^on/i.test(attribute.name)) {
          element.removeAttribute(attribute.name);
        }
        if (
          /^(href|xlink:href)$/i.test(attribute.name) &&
          attribute.value &&
          !attribute.value.startsWith('#')
        ) {
          throw new Error(
            window.SmoofI18n.legacy('Das SVG-Logo verweist auf eine externe Datei.')
          );
        }
      });
    });

    return root;
  }

  function prefixVectorIds(root, prefix) {
    const replacements = new Map();
    root.querySelectorAll('[id]').forEach(element => {
      const oldId = element.id;
      const nextId = `${prefix}-${oldId}`;
      replacements.set(oldId, nextId);
      element.id = nextId;
    });

    root.querySelectorAll('*').forEach(element => {
      Array.from(element.attributes).forEach(attribute => {
        let value = attribute.value;
        replacements.forEach((nextId, oldId) => {
          value = value
            .replaceAll(`url(#${oldId})`, `url(#${nextId})`)
            .replaceAll(`#${oldId}`, `#${nextId}`);
        });
        if (value !== attribute.value) {
          element.setAttribute(attribute.name, value);
        }
      });
    });
  }

  async function appendVectorLogo(svg, logo, sequence) {
    if (!logo?.visible || !logo?.hasLogo || !logo?.src) return;

    const sourceRoot = await vectorLogoDocument(logo);
    const viewBox = String(sourceRoot.getAttribute('viewBox') || '')
      .trim()
      .split(/[\s,]+/)
      .map(Number);

    if (viewBox.length !== 4 || viewBox.some(value => !Number.isFinite(value)) || viewBox[2] <= 0 || viewBox[3] <= 0) {
      throw new Error(window.SmoofI18n.legacy('Das SVG-Logo besitzt keine gültige viewBox.'));
    }

    const [minX, minY, sourceWidth, sourceHeight] = viewBox;
    const scale = Math.min(
      Number(logo.width) / sourceWidth,
      Number(logo.height) / sourceHeight
    );
    const offsetX = Number(logo.x) + (Number(logo.width) - sourceWidth * scale) / 2;
    const offsetY = Number(logo.y) + (Number(logo.height) - sourceHeight * scale) / 2;
    const outer = createSvgElement('g', {
      transform: `rotate(${Number(logo.rotation) || 0} ${Number(logo.x) + Number(logo.width) / 2} ${Number(logo.y) + Number(logo.height) / 2})`,
      opacity: logo.opacity ?? 1,
      'data-smoof-laser-vector-logo': String(sequence)
    });
    const background = logoBackgroundBox(logo);

    if (background) {
      outer.appendChild(createSvgElement(
        background.shape === 'circle' ? 'circle' : 'rect',
        background.shape === 'circle'
          ? {
              cx: background.x + background.width / 2,
              cy: background.y + background.height / 2,
              r: background.width / 2,
              fill: background.color
            }
          : {
              x: background.x,
              y: background.y,
              width: background.width,
              height: background.height,
              rx: background.shape === 'rounded'
                ? Math.min(background.width, background.height) * 0.25
                : 0,
              fill: background.color
            }
      ));
    }

    const vector = createSvgElement('g', {
      transform: `translate(${offsetX} ${offsetY}) scale(${scale}) translate(${-minX} ${-minY})`
    });
    const importedRoot = document.importNode(sourceRoot, true);
    prefixVectorIds(importedRoot, `smoof-logo-${sequence}`);
    Array.from(importedRoot.childNodes).forEach(child => {
      vector.appendChild(child);
    });
    outer.appendChild(vector);
    svg.appendChild(outer);
  }

  function forceLaserBlackVector(svg) {
    svg.querySelectorAll('*').forEach(element => {
      ['fill', 'stroke', 'stop-color'].forEach(attribute => {
        const value = element.getAttribute(attribute);
        if (value) element.setAttribute(attribute, laserBlackColor(value));
      });

      if (element.style) {
        ['fill', 'stroke', 'stopColor'].forEach(property => {
          const value = element.style[property];
          if (value) element.style[property] = laserBlackColor(value);
        });
        element.style.opacity = '1';
        element.style.fillOpacity = '1';
        element.style.strokeOpacity = '1';
      }

      element.setAttribute('opacity', '1');
      if (element.hasAttribute('fill-opacity')) element.setAttribute('fill-opacity', '1');
      if (element.hasAttribute('stroke-opacity')) element.setAttribute('stroke-opacity', '1');
      element.removeAttribute('filter');
    });
  }

  function assertStrictVectorSvg(svg) {
    const invalid = svg.querySelector(
      'image, text, tspan, foreignObject, script, video, canvas, iframe'
    );

    if (invalid) {
      throw new Error(
        `Laserexport enthält ein unzulässiges Element: <${invalid.tagName.toLowerCase()}>.`
      );
    }

    svg.querySelectorAll('[href], [xlink\\:href]').forEach(element => {
      const href = element.getAttribute('href') || element.getAttribute('xlink:href') || '';
      if (href && !href.startsWith('#')) {
        throw new Error(window.SmoofI18n.legacy('Laserexport enthält eine externe Dateireferenz.'));
      }
    });
  }

  async function renderLaserSvg({
    diameter = getPrintDiameterMm(),
    model = readModel(),
    surface = 'front'
  } = {}) {
    if(window.SmoofCurvedText)model=await window.SmoofCurvedText.prepare(model);
    window.SmoofCurvedText?.assertReady(model);
    await verifyExtraStyles(model);
    await ensureCanvasFonts(model);
    const trimDiameterMm = Number(diameter) || 80;
    const laserEdgeMarginMm = Math.max(
      0,
      Number(window.SmoofProductProfiles?.current?.editorPolicy?.laserEdgeMarginMm) || 0
    );

    if (model.backgroundImage?.dataUrl) {
      throw new Error(
        window.SmoofI18n.legacy('Hintergrundbilder sind für die Lasergravur nicht zulässig. Bitte verwenden Sie ausschließlich Vektorobjekte.')
      );
    }

    const laserModel = monochromeModel(model);
    const svg = await buildSvg(laserModel, {
      includeBackground: false,
      includeEditableText: false,
      includeUploadedLogo: false,
      includeLogoPlaceholder: false,
      includeBrandDot: false,
      includeProofEditorQr: false,
      includeNfcIcon: false
    });
    const trimSize = PRINT_RADIUS * 2;

    svg.setAttribute(
      'viewBox',
      `${500 - PRINT_RADIUS} ${500 - PRINT_RADIUS} ${trimSize} ${trimSize}`
    );
    svg.setAttribute('width', `${trimDiameterMm}mm`);
    svg.setAttribute('height', `${trimDiameterMm}mm`);
    svg.setAttribute('data-smoof-production-process', 'laser');
    svg.setAttribute('data-smoof-production-surface', surface);
    svg.setAttribute('data-smoof-laser-edge-margin-mm', String(laserEdgeMarginMm));

    await replaceSvgTextWithOutlines(svg);

    const paymentGroup = svg.querySelector(
      '[data-smoof-payment-group-rendered]'
    );
    paymentGroup?.remove();

    for (const item of laserModel.texts || []) {
      const outline = await outlinedTextGroup(item);
      if (outline) svg.appendChild(outline);
    }

    const logos = [
      laserModel.logo,
      laserModel.logoCopy,
      laserModel.logoDuplicate
    ];
    for (let index = 0; index < logos.length; index += 1) {
      await appendVectorLogo(svg, logos[index], index + 1);
    }

    if (paymentGroup) svg.appendChild(paymentGroup);

    const numberOutline = await outlinedTextGroup(laserModel.number);
    if (numberOutline) svg.appendChild(numberOutline);

    if (laserModel.brandDot?.visible) {
      svg.appendChild(createSvgElement('circle', {
        cx: laserModel.brandDot.x,
        cy: laserModel.brandDot.y,
        r: laserModel.brandDot.radius,
        fill: laserModel.brandDot.color || '#000000',
        opacity: laserModel.brandDot.opacity ?? 1
      }));
    }

    const panel = qrPanel(laserModel);
    const metadata = createSvgElement('metadata');
    const laserQrVisible = qrVisible(laserModel);
    metadata.textContent = JSON.stringify({
      schema: 'smoof-laser-vector-1.0',
      surface,
      trimDiameterMm,
      laserEdgeMarginMm,
      usableDiameterMm: Math.max(0, trimDiameterMm - laserEdgeMarginMm * 2),
      qrPlaceholder: laserQrVisible
        ? {
            x: panel.x,
            y: panel.y,
            width: panel.width,
            height: panel.height,
            radius: panel.radius
          }
        : null,
      qrPayload: laserQrVisible
        ? 'insert-during-final-production'
        : 'none'
    });
    svg.insertBefore(metadata, svg.firstChild);
    if (laserQrVisible) {
      svg.appendChild(createSvgElement('rect', {
        id: 'smoof-qr-reserved-zone',
        x: panel.x,
        y: panel.y,
        width: panel.width,
        height: panel.height,
        rx: panel.radius,
        fill: 'none',
        stroke: 'none',
        'data-smoof-production-placeholder': 'qr'
      }));
    }

    forceLaserBlackVector(svg);
    assertStrictVectorSvg(svg);

    const source = serializeSvg(svg);
    return {
      source,
      bytes: new TextEncoder().encode(source),
      trimDiameterMm,
      pageSizeMm: trimDiameterMm,
      bleedMm: 0,
      dpi: null,
      format: 'svg',
      mimeType: 'image/svg+xml',
      surface,
      vectorOnly: true,
      qr: {
        visible: laserQrVisible,
        codeColor: '#000000',
        backingVisible: false,
        backingColor: qrBackingColor(laserModel)
      }
    };
  }

  function orderSafeModel(
    model
  ) {
    const safeTexts =
      (model.texts || [])
        .map(item => {
          const {
            editing,
            ...safeItem
          } = item;

          return safeItem;
        });

    const {
      editing:
        numberEditing,
      ...safeNumber
    } = model.number || {
      visible: false
    };

    return {
      ...model,
      texts: safeTexts,
      number: safeNumber,
      logo: {
        ...model.logo,
        src:
          model.logo?.hasLogo
            ? ''
            : ''
      },
      logoCopy: {
        ...model.logoCopy,
        src: ''
      },
      logoDuplicate: {
        ...model.logoDuplicate,
        src: ''
      }
    };
  }

  function syncOrderModel(
    model
  ) {
    const form =
      productForm();

    if (!form) return;

    setProperty(
      form,
      'properties[_SMOOF Design Schema]',
      VERSION
    );

    setProperty(
      form,
      'properties[_SMOOF Design State]',
      JSON.stringify(
        orderSafeModel(model)
      )
    );
  }

  function ensureLiveSvg(stage) {
    if (
      liveSvg?.isConnected &&
      currentStage === stage
    ) {
      return liveSvg;
    }

    liveSvg?.remove();

    liveSvg =
      createSvgElement(
        'svg',
        {
          viewBox:
            `0 0 ${VIEWBOX_SIZE} ${VIEWBOX_SIZE}`,
          preserveAspectRatio:
            'xMidYMid meet',
          'aria-hidden': 'true'
        }
      );

    liveSvg.dataset
      .smoofVectorPreview =
      'true';

    stage.appendChild(liveSvg);
    currentStage = stage;

    return liveSvg;
  }

  function ensureLiveTextCanvas(stage) {
    if (
      liveTextCanvas?.isConnected &&
      liveTextCanvas.parentElement === stage
    ) {
      return liveTextCanvas;
    }

    liveTextCanvas?.remove();

    liveTextCanvas = document.createElement('canvas');
    liveTextCanvas.width = VIEWBOX_SIZE;
    liveTextCanvas.height = VIEWBOX_SIZE;
    liveTextCanvas.dataset.smoofLiveTextCanvas = 'v3-3';
    liveTextCanvas.setAttribute('aria-hidden', 'true');
    Object.assign(liveTextCanvas.style, {
      position: 'absolute',
      inset: '0',
      zIndex: '56',
      display: 'block',
      width: '100%',
      height: '100%',
      pointerEvents: 'none'
    });

    stage.appendChild(liveTextCanvas);
    return liveTextCanvas;
  }

  function drawLiveCanvasText(canvas, model) {
    const context = canvas.getContext('2d');
    if (!context) return false;

    context.clearRect(0, 0, VIEWBOX_SIZE, VIEWBOX_SIZE);

    (model.texts || []).forEach(item => {
      if (!item?.editing) drawCanvasText(context, item);
    });

    if (!model.number?.editing) {
      drawCanvasText(
        context,
        model.number,
        1
      );
    }

    return true;
  }

  async function renderLive() {
    const sequence =
      ++renderSequence;

    const stage =
      stageElement();

    if (!stage) {
      liveSvg?.remove();
      liveSvg = null;
      liveTextCanvas?.remove();
      liveTextCanvas = null;
      currentStage = null;

      setLiveHtmlLogoVisibility(
        false
      );

      delete document
        .documentElement
        .dataset
        .smoofVectorPreviewActive;

      return;
    }

    const model =
      readModel();

    const [rendered] =
      await Promise.all([
        buildSvg(
          model,
          {
            proof: false,
            includeEditableText:
              false,
            includeUploadedLogo:
              false
          }
        ),
        ensureCanvasFonts(model)
      ]);

    if (
      sequence !== renderSequence
    ) {
      return;
    }

    const target =
      ensureLiveSvg(stage);

    // Compare the actual next tree, including attributes and text. No model
    // fingerprint or cached output can suppress a real change or a remount.
    const nextChildren = Array.from(rendered.childNodes);
    const currentChildren = Array.from(target.childNodes);
    if (currentChildren.length !== nextChildren.length ||
        nextChildren.some((node, index) => !node.isEqualNode(currentChildren[index]))) {
      target.replaceChildren(...nextChildren);
    }

    refreshLiveImageReferences(
      target
    );

    drawLiveCanvasText(
      ensureLiveTextCanvas(stage),
      model
    );

    setLiveHtmlLogoVisibility(
      true
    );

    syncOrderModel(model);

    document.documentElement
      .dataset
      .smoofVectorPreviewActive =
      'true';

    const marker =
      document.querySelector(
        '#smoof-preview-extension'
      );

    if (marker) {
      marker.dataset
        .smoofVectorRendererStatus =
        'active';

      marker.dataset
        .smoofVectorRendererVersion =
        VERSION;
    }
  }

  function scheduleRender() {
    if (renderPending) return;

    renderPending = true;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        renderPending = false;

        renderLive().catch(error => {
          console.error(
            'SMOOF vector renderer failed',
            error
          );
        });
      });
    });
  }

  window.SmoofDesignRenderer = {
    version: VERSION,
    build: RENDERER_BUILD,
    revision: RENDERER_REVISION,
    extraStyleBuild: EXTRA_STYLE_BUILD,
    resolveCurvedFont: laserFont,
    curvedFontPath: path => unionFontPathData(fontPathData(path)),
    readModel,
    buildSvg,
    capabilities: Object.freeze({transparentPreviewBackground:true}),
    renderPng,
    renderProductionPng,
    renderLaserSvg,
    serializeSvg,
    scheduleRender
  };

  document.addEventListener(
    'input',
    scheduleRender,
    true
  );

  document.addEventListener(
    'change',
    scheduleRender,
    true
  );

  document.addEventListener(
    'pointerup',
    scheduleRender,
    true
  );

  window.addEventListener(
    'resize',
    scheduleRender
  );

  window.addEventListener(
    'smoof:editor-reset',
    scheduleRender
  );

  window.setInterval(
    scheduleRender,
    350
  );

  scheduleRender();
})();
